<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Console Booking Details</b-navbar-brand>
        </b-navbar>

        <b-card>
          <div class="row align-items-end">
            
            <div class="col-md-6">
              <b-button
                v-if="($route.path=='/consoleBooking' && $sessionsStorage.get('add_console_booking_pre') === '1')"
                size="sm"
                class="pull-left"
                @click="AddBookingConsole()"
                variant="primary"
                >Add Console Booking</b-button
              >
              <!-- <b-button variant="primary" @click="openContractModal()" id="addButtonLoader" size="sm"  class="ml-2">Add Contract</b-button>
              <b-button variant="primary" @click="openVesselModal()" id="addButtonLoader" size="sm" class="ml-2">Add Vessel</b-button> -->
              <b-button
                v-if="($route.path=='/consoleBooking' && ($sessionsStorage.get('designation') == 'Admin' ||
                    $sessionsStorage.get('nameUser') == 'Bhavneesh'))"
                size="sm"
                class="pull-left  ml-2"
                @click="AddBookingConsoleModal('add', '')"
                variant="primary"
                >Add Dummy Booking</b-button
              >
              <!-- <b-button
                v-if="($route.path=='/consoleBooking')"
                size="sm"
                class="pull-left  ml-2"
                @click="AddBookingConsoleModal('add', '')"
                variant="primary"
                >Add Console Booking</b-button
              > -->
            </div>
            <div class="col-md-6"></div>
            <div class="col-md-3">
              <label for="blType">Date</label>
              <date-range-picker
                :opens="openRight"
                :always-show-calendars="showCal"
                v-model="dateRange"
                :startDate="startDate"
                :endDate="endDate"
                :locale-data="locale"
              ></date-range-picker>
            </div>
            <div class="col-md-3">
              <label for="blType">BRF No</label>
              <b-form-input
                :formatter="capitalizeAll"
                v-model="BRFNoFilter"
                type="text"
                placeholder="Enter BRF No"
              ></b-form-input>
            </div>
            <div class="col-md-3">
              <label for="blType">Booking No</label>
              <b-form-input
                :formatter="capitalizeAll"
                v-model="BookingNoFilter"
                type="text"
                placeholder="Enter Booking No"
              ></b-form-input>
            </div>
            <div class="col-md-3">
              <label for="blType">Client Name</label>
              <model-list-select
                :list="clientMaster"
                id="clientName"
                v-model="clientIdFilter"
                option-value="clientId"
                option-text="clientName"
                placeholder="Select Client Name"
              ></model-list-select>
            </div>
            <div class="col-md-3">
          <label for="agentName">
            Agent Name :
            <span class="error">*</span>
          </label>
          <model-list-select
            :list="$store.getters['common/getAllAgentColoaderList']"
            option-value="agntColoaderId"
            option-text="agentName"
            class="ml-2"
            v-model="agentIdFilter"
            placeholder="Select Agent Name"
          ></model-list-select>
        </div>
            <div class="col-md-3">
              <label for="blType">Shipping Line</label>
              <model-list-select
                :list="ShippingLineList"
                v-model="ShippingLineFilter"
                option-value="shippingId"
                option-text="shippingLine"
                placeholder="Select Shipping Line"
              ></model-list-select>
            </div>
            <div class="col-md-3">
              <label for="blType">Branch</label>
              <model-list-select
                :isDisabled="
                  $sessionsStorage.get('cust_username') == 'Admin' ||
                  $sessionsStorage.get('cust_username') == 'admin' ||
                  $sessionsStorage.get('cust_username') == 'shankarrawat' ||
                  $sessionsStorage.get('cust_username') == 'vijaysharma' ||
                  $sessionsStorage.get('cust_username') == 'rathishnair' ||
                  $sessionsStorage.get('cust_username') == 'aaryav'
                    ? false
                    : true
                "
                :list="BranchList"
                v-model="BranchFilter"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder="Select Branch"
              ></model-list-select>
            </div>
            <div class="col-md-3">
              <label for="blType">Booking Status</label>
              <model-list-select
                :list="BookingStatusList"
                id="BookingStatus"
                v-model="BookingStatusFilter"
                option-value="inv"
                option-text="int"
                placeholder="Select Status"
              ></model-list-select>
            </div>
            <div class="col-md-3">
              <label for="blType">POR</label>
              <model-list-select
                @input="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                :list="finalAllPlaceDataPOR"
                v-model="PORfilter"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder="Select Place of Receipt"
              ></model-list-select>
            </div>
            <div class="col-md-3">
              <label for="blType">POD</label>
              <model-list-select
                @input="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                :list="finalAllPlaceDataPOD"
                v-model="PODfilter"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder="Select Port of Discharge"
              ></model-list-select>
            </div>
            <div class="col-md-3">
              <label for="blType">POL</label>
              <model-list-select
                @input="getLocationList($event, 'All', 'finalAllPlaceDataLP')"
                @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataLP')"
                :list="finalAllPlaceDataLP"
                v-model="POLfilter"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder="Select Load Port"
              ></model-list-select>
            </div>
            <div class="col-md-3">
               <label>Contract No</label>
              <model-list-select class="ml-1" :list="$store.getters['common/getAllContractList']"
                id="fk_contract_id" v-model="fk_contract_idFilter" option-value="value" option-text="label"
                placeholder="Select Contract NUMBER" @input="getContractNoBasedVessel(fk_contract_idFilter)"  />
            </div>
            
            <div class="col-md-3">
               <label>Vessel Name </label>
              <model-list-select class="ml-1" :list="$store.getters['common/getAllContractBasedVesselList']"
              id="vessel_name" v-model="fk_ccbm_idFilter" option-value="value" option-text="label"
              placeholder="Select Vessel Name" />
            </div>

            <div class="col-md-12 mt-2 text-right">
              <b-button size="sm" @click="filterSearch" variant="outline-primary"
                >Search</b-button
              >
              <b-button size="sm" class="ml-3" @click="clearFilter" variant="outline-info"
                >clear</b-button
              >
              <!-- <b-button
                size="sm"
                class="ml-3"
                @click="getReports('ConsoleBooking_SCREEN')"
                variant="outline-info"
                >Export as Excel</b-button
              > -->
              <b-button
              v-if="($route.path=='/consoleBooking' || ($sessionsStorage.get('designation') == 'Admin' &&
                    $sessionsStorage.get('nameUser') == 'Bhavneesh'))"
                :disabled="ExcelBtnName != 'Export as Excel' ? true : false"
                class="ml-3"
                @click="getReports('ConsoleBooking_SCREEN', 'Export as Excel')"
                size="sm"
                variant="outline-info"
                >{{ ExcelBtnName }}
                <b-spinner
                  v-if="ExcelBtnName != 'Export as Excel'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>
            </div>
          </div>

          <b-modal no-close-on-esc no-close-on-backdrop class="w-90" size="xl" ref="Contract-modal" hide-footer
          title="Add Contract">
          <b-row>
            <b-col md="12">
              <label>Contract No <span class="error">*</span></label>
              <b-form-input :disabled="contractModal.cb_id > 0 ? true : false" size="sm" :formatter="capitalizeAll"
                id="cb_contarct_no" name="cb_contarct_no" v-model="contractModal.cb_contarct_no" :style="{
                  borderColor:
                    !contractModal.cb_contarct_no && errorContractList.cb_contarct_no
                      ? 'red'
                      : '',
                }"></b-form-input>
              <span class="error" v-if="!contractModal.cb_contarct_no">{{
                errorContractList.cb_contarct_no
              }}</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="my-3 text-center">
              <b-button :disabled="contractDisabled" variant="outline-primary" @click="addContract" id="addButtonLoader"
                size="sm">Save</b-button>
              <b-button variant="outline-danger" class="ml-2" size="sm" @click="hideContractModal">Close</b-button>
            </b-col>
          </b-row>
        </b-modal>

          <b-modal no-close-on-esc no-close-on-backdrop size="xl" ref="vesselModalRef" hide-footer
          :title="'Add Vessel/Voyage-' + ConsoleBookDetails.contract_no">
          <b-row>
            <b-col md="6">
              <label>Contract No <span class="error">*</span></label>
              <model-list-select class="ml-1" :list="$store.getters['common/getAllContractList']"
                id="fk_contract_id" v-model="vesselModal.fk_contract_id" option-value="value" option-text="label"
                placeholder="Select Contract NUMBER" @input="getContractNo(vesselModal.fk_contract_id)" :style="{
                  borderColor:
                    !vesselModal.fk_contract_id && errorVesselList.fk_contract_id
                      ? 'red'
                      : '',
                }" />
              <span class="error" v-if="!vesselModal.fk_contract_id && errorVesselList.fk_contract_id">
                {{ errorVesselList.fk_contract_id }}
              </span>
            </b-col>
            <b-col md="6">
              <label>Vessel Name <span class="error">*</span></label>
              <b-form-input size="sm" :formatter="capitalizeAll" id="vessel_name" name="vessel_name"
                v-model="vesselModal.vessel_name" :style="{
                  borderColor:
                    !vesselModal.vessel_name && errorVesselList.vessel_name
                      ? 'red'
                      : '',
                }"></b-form-input>
              <span class="error" v-if="!vesselModal.vessel_name">{{
                errorVesselList.vessel_name
              }}</span>
            </b-col>

            <b-col md="6">
              <label>Voyage No <span class="error">*</span></label>
              <b-form-input size="sm" :formatter="capitalizeAll" id="vessel_voyage_no" name="vessel_voyage_no"
                v-model="vesselModal.vessel_voyage_no" :style="{
                  borderColor:
                    !vesselModal.vessel_voyage_no && errorVesselList.vessel_voyage_no
                      ? 'red'
                      : '',
                }"></b-form-input>
              <span class="error" v-if="!vesselModal.vessel_voyage_no">{{
                errorVesselList.vessel_voyage_no
              }}</span>
            </b-col>

            <b-col md="6">
              <label>SOB <span class="error">*</span></label>
              <b-form-input type="date" v-model="vesselModal.vessel_sail_date" :style="{
                borderColor:
                  !vesselModal.vessel_sail_date && errorVesselList.vessel_sail_date ? 'red' : '',
              }" />
              <span class="error" v-if="!vesselModal.vessel_sail_date">{{
                errorVesselList.vessel_sail_date
              }}</span>
            </b-col>

          </b-row>
          <b-row>
            <b-col class="my-3 text-center">
              <b-button :disabled="contractDisabled" variant="outline-primary" @click="addVesselVoyage"
                id="addButtonLoader" size="sm">Save</b-button>
              <b-button variant="outline-danger" class="ml-2" size="sm" @click="hideVesselModal">Close</b-button>
            </b-col>
          </b-row>
        </b-modal>

          <b-row>
            <b-col cols="12" class="ml-2 text-right"></b-col>
          </b-row>
        </b-card>

        <div class="box">
          <div>
            <b-pagination
              class="mt-3"
              limit="25"
              style="margin: 0px"
              align="center"
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="totalRows"
              @change="onPageChange($event)"
            ></b-pagination>
          </div>
          <div>
            <b-row class="align-content-end mt-3">
              <b-col cols="8">
                <!-- <input
                  type="checkbox"
                  @click="SelectAll(consoBooking)"
                  v-model="isCheckAll"
                />
                <label
                  >Select / Deselect All Count({{
                    this.AllBookingNo_ids.length
                  }})</label
                >-->
              </b-col>
              <b-col cols="2">
                <h5 class="text-muted pull-right">
                  <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                </h5>
              </b-col>
              <b-col cols="2" style="padding: 0px 1rem 0 5rem">
                <model-list-select
                  :list="PaginationList"
                  v-model="PaginationCount"
                  option-value="pagv"
                  option-text="pagt"
                  placeholder="Select"
                  @input="pagechangeData()"
                ></model-list-select>
              </b-col>
            </b-row>
          </div>

          <div class="table-responsive tableMain mt-2">
            <b-table
              show-empty
              stacked="md"
              :items="consoBooking"
              :fields="fields"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
            >
              <template slot="SN" slot-scope="row0">
                <!-- <input
                  v-if="row0.item.revisedActionTakenFromMail != 1"
                  type="checkbox"
                  v-bind:value="row0.item.allModuleId"
                  v-bind:id="row0.item.ClientName"
                  v-model="AllBookingNo_ids"
                  @change="updateSelectAll($event, row0.item)"
                />-->
                <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
              </template>
              <template slot="booking_no" slot-scope="row1">
                <span v-if="row1.item.bookingType">
                  Booking Type. :{{ row1.item.bookingType }}
                  <br />
                </span>
                <!-- <span v-if="row1.item.bookingType === 'ON CONTRACT'"> -->
                <span v-if="row1.item.contract_no">
                  Contract No. :{{ row1.item.contract_no }}
                  <br />
                </span>
                <b :style="row1.item.SubscriptionId?'color: blue;font-weight:bold':''" @click="row1.item.SubscriptionId?goToSubscriptionPage(row1.item):''">{{ row1.item.booking_no }}</b>
                <br />
                <BookingTrack 
                v-if="row1.item.SubscriptionId"
                :containerArr="''"
                :slineName="row1.item.shippingLine"
                :clientName="row1.item.ClientName"
                :modal_title="`Container Movement Booking No: ${row1.item.booking_no} Job No - ${row1.item.mainSeries} Client: ${row1.item.ClientName}`"
                :JOBNO="row1.item.mainSeries" :shipment_id="Number(0)" :subscription_id="Number(0)" :fk_sub_track_id="Number(0)"
                :fk_all_module_id="Number(row1.item.allModuleId)" :fk_booking_id="Number(row1.item.booking_id)"
                :fk_container_id="Number(0)" :booking_number="row1.item.booking_no" :container_number="''" />
                <span>
                  Created Dt. :{{ row1.item.created_at | moment }}
                  <br />
                </span>
                <span>Release Dt. :{{ row1.item.release_date | moment }}</span>
                <br />
                <span>
                  Raised From : {{ row1.item.raisedFrom }}
                  <br />
                </span>
                <span>By : {{ row1.item.raisedBy }}</span>
                <br />
                <span v-if="row1.item.enquiry_booking_no">
                  BRF No. :<b>{{ row1.item.enquiry_booking_no }}</b>
                  <br />
                </span>
                <span v-if="row1.item.enquiry_no">
                  Enq No. :<b>{{ row1.item.enquiry_no }}</b>
                  <br />
                </span>
                <span class="error" v-if="row1.item.UpdatedBy">
                  Update Dt : {{ row1.item.UpdatedDate }}
                  <br />
                </span>
                <span class="error" v-if="row1.item.UpdatedBy"
                  >Update By : {{ row1.item.UpdatedBy }}</span
                >
                <br />
              </template>
              <template slot="ClientName" slot-scope="row2">
                <b v-if="row2.item.booking_for">{{ "Booking For : "+row2.item.booking_for }}</b><br/>
                <b v-if="row2.item.fk_agent_id == '0' && row2.item.booking_for=='Agent'">{{ "NOT AVAILABLE" }}</b>
                <b v-else-if="row2.item.AgentName != '' && row2.item.booking_for=='Agent'">{{ row2.item.AgentName }}</b><br/>
                <b v-if="row2.item.fk_client_id == '0' && row2.item.booking_for=='Client'">{{ "NOT AVAILABLE" }}</b>
                <b v-else-if="row2.item.ClientName != '' && row2.item.booking_for=='Client'">{{ row2.item.ClientName }}</b>

                <b v-if="row2.item.fk_agent_id == '0' && !row2.item.booking_for">{{ "NOT AVAILABLE" }}</b>
                <b v-else-if="row2.item.AgentName != '' && !row2.item.booking_for">{{ row2.item.AgentName }}</b><br/>
                <b v-if="row2.item.fk_client_id == '0' && !row2.item.booking_for">{{ "NOT AVAILABLE" }}</b>
                <b v-else-if="row2.item.ClientName != '' && !row2.item.booking_for">{{ row2.item.ClientName }}</b>
              </template>
              <template slot="shippingLine" slot-scope="row3">
                <b v-if="row3.item.shippingLine != ''">{{ row3.item.shippingLine }}</b>
              </template>
              <template slot="POD" slot-scope="row3">
                Branch :
                <b v-if="row3.item.Branch_Name != ''">
                  {{ row3.item.Branch_Name }}
                </b>
                <br />POR :
                <b v-if="row3.item.POR != ''">{{ row3.item.POR }}</b>
                <br />POD :
                <b v-if="row3.item.POD != ''">{{ row3.item.POD }}</b>
                <br />POL :
                <b v-if="row3.item.POL != ''">{{ row3.item.POL }}</b>
                <br />
              </template>
              <template slot="vessel_sale_start_date" slot-scope="row10">
                <b v-if="row10.item.validity_start != ''"
                  >Validity Date : {{ row10.item.validity_start }}</b
                >
                <br />
                <b v-if="row10.item.validity_end != ''">/{{ row10.item.validity_end }}</b>
                <br />
                <b v-if="row10.item.vessel_sale_start_date != ''"
                  >Vessel Sail Date : {{ row10.item.vessel_sale_start_date }}</b
                >
                <br />
                <b v-if="row10.item.vessel_sale_end_date != ''"
                  >/{{ row10.item.vessel_sale_end_date }}</b
                >
                <br />
              </template>
              <template slot="mainSeries" slot-scope="row6">{{
                row6.item.mainSeries
              }}</template>
              <template slot="BookingStatus" slot-scope="row5" v-if="($route.path=='/consoleBooking' || ($sessionsStorage.get('designation') == 'Admin' &&
                    $sessionsStorage.get('nameUser') == 'Bhavneesh'))">
                <!-- {{
                  row5.item.validity_docArr != undefined
                    ? sanitizedArray(row5.item.validity_docArr)
                    : []
                }} -->
                   <span v-if="row5.item.validity_docArr">
              <b v-if="row5.item.validity_docArr.length > 0">
                <span
                  v-for="(item_doc, index_doc) in sanitizedArray(row5.item.validity_docArr)"
                  :key="index_doc"
                >
                <b-button
                    style="margin-left: 2px; font-size: 0.675rem"
                    v-if="item_doc != '' && row5.item.BookingStatus == '1'"
                    @click="PrintValidity_Doc(item_doc)"
                    size="sm"
                    variant="warning"
                    class="mb-1"
                    >PDF</b-button
                  >
                  <!-- <a
                     v-if="item_doc != '' && row5.item.BookingStatus == '1'"
                    href="javascript:void(0)"
                    @click="PrintValidity_Doc(item_doc)"
                    >PDF</a
                  > -->
                  <br />
                </span>
              </b>
              <b v-else>
                <a
                  v-if="
                    row5.item.validity_docArr != '' &&
                    row5.item.validity_docArr != undefined &&
                    row5.item.validity_docArr != null
                   && row5.item.BookingStatus == '1'
                  "
                  href="javascript:void(0)"
                   style="margin-left: 2px; font-size: 0.675rem"
                   size="sm"
                    variant="warning"
                  @click="PrintValidity_Doc(row5.item.validity_docArr)"
                  >PDF</a
                >
              </b>
            </span>
                <!-- <span
                  v-for="(doc_item, doc_index) in row5.item.validity_docArr != undefined
                    ? sanitizedArray(row5.item.validity_docArr)
                    : []"
                  :key="doc_index"
                >
                  <b-button
                    style="margin-left: 2px; font-size: 0.675rem"
                    v-if="doc_item != '' && row5.item.BookingStatus == '1'"
                    @click="PrintValidity_Doc(doc_item)"
                    size="sm"
                    variant="warning"
                    >PDF</b-button
                  >
                </span> -->
                <br />
                <b-button
                  style="font-size: 0.675rem"
                  class="mt-1"
                  variant="success"
                  @click="row5.item.approval_request == '1'?sendApprovalRequestModal(row5.item):getApprovalRequestLog(row5.item)"
                >
                   {{row5.item.approval_request == '1'?'Send Approval Request':'Request Approval Log'}}
                  <br />
                </b-button>
                <b-button
                  v-if="row5.item.BookingStatus == '1' && (row5.item.approval_request == '0' && row5.item.is_approval_mail_action=='0')"
                  style="font-size: 0.675rem"
                  class="mt-1"
                  variant="success"
                  @click="AddOtherCBDetails('edit', row5.item)"
                >
                  RELEASED
                  <br />
                </b-button>
                <b-button
                  v-else-if="row5.item.BookingStatus == '2' && (row5.item.approval_request == '0' || row5.item.is_approval_mail_action=='1')"
                  style="font-size: 0.675rem"
                  class="mt-1"
                  @click="AddOtherCBDetails('add', row5.item)"
                  variant="danger"
                >
                  UNRELEASED
                  <br />
                </b-button>
                <b-button
                  v-else-if="row5.item.BookingStatus == 3"
                  style="font-size: 0.675rem"
                  class="mt-1"
                  @click="RemoveBookingConsole('CANCELLED', row5.item)"
                  variant="warning"
                  >CANCELLED</b-button
                >
                <br />
                <span v-if="row5.item.BookingStatus == 3 && row5.item.closedBy != ''">
                  CANCELLED By:{{ wordWrap(row5.item.closedBy, 24) }}
                  <br />
                  CANCELLED Remark:{{ wordWrap(row5.item.closingReasontxt, 24) }}
                </span>
              </template>
              <template slot="booking_id" slot-scope="row4" v-if="($route.path=='/consoleBooking' || ($sessionsStorage.get('designation') == 'Admin' &&
                    $sessionsStorage.get('nameUser') == 'Bhavneesh'))">
                <b-button
                  v-if="
                    $sessionsStorage.get('designation') == 'Admin' &&
                    $sessionsStorage.get('nameUser') == 'Bhavneesh'
                  "
                  style="font-size: 0.675rem"
                  size="sm"
                  class="mb-1"
                  @click="AddBookingConsoleModal('edit', row4.item)"
                  variant="primary"
                >
                  Edit
                  <br />
                 
                </b-button>
                <BRFCard
                      v-if="row4.item.prbr_id>0"
                      :BRFDetails="row4.item"
                      :prbr_id="Number(row4.item.prbr_id)"
                    />
                  <span>Used Status: {{row4.item.is_subscription_tracking_status}}</span>
                 <b-button
                  v-if="$sessionsStorage.get('designation') == 'Admin' && row4.item.is_subscription_tracking_status=='Yes'"
                  style="font-size: 0.675rem"
                  size="sm"
                  class="mb-1"
                  @click="ResetBookingConsole(row4.item)"
                  variant="primary"
                >
                  Reset Booking 
                  <br />
                </b-button>
                <br />
                <ToggleBRFSwitch v-if="row4.item.prbr_id > 0 && row4.item.booking_id > 0 && $sessionsStorage.get('designation') == 'Admin' &&
                    $sessionsStorage.get('nameUser') == 'Bhavneesh'" 
                   :brf_no="row4.item.enquiry_booking_no"
                    :booking_no="row4.item.booking_no"
                    :booking_id="Number(row4.item.booking_id)"
                    :prbr_id="Number(row4.item.prbr_id)"
                    :isbookingactive="Number(row4.item.isbookingactive)"
                    :prbr_is_active="Number(row4.item.prbr_is_active)"
                    :request_type="'ConsoleBooking'"
                    @success="viewBookingConsoleList" />
                     <br />
                <b-button
                  v-if="
                    $sessionsStorage.get('designation') == 'Admin' &&
                    $sessionsStorage.get('nameUser') == 'Bhavneesh'
                  "
                  style="font-size: 0.675rem"
                  size="sm"
                  class="mb-1"
                  @click="
                    RemoveBookingConsole(
                      row4.item.isbookingactive == 1 ? 'remove' : 'recover',
                      row4.item
                    )
                  "
                  :variant="row4.item.isbookingactive == 1 ? 'danger' : 'success'"
                >
                  {{ row4.item.bookingactive_status_txt }}
                  <br />
                </b-button>
                <br />
                <b-button
                  :disabled="row4.item.assignmentNumber ? true : false"
                  v-if="row4.item.booking_id != '' && row4.item.BookingStatus != 3"
                  style="margin-left: 2px; font-size: 0.675rem"
                  size="sm"
                  class="ml-2 mb-1"
                  @click="CancelBooking(row4.item, '3')"
                  variant="danger"
                >
                  Cancel
                  <br />
                </b-button>
                <br />
                <span v-if="row4.item.assignmentNumber != ''">
                  {{ row4.item.assignmentNumber }}
                </span>
              </template>
            </b-table>
          </div>
        </div>

        <div>
          <b-pagination
            limit="25"
            align="center"
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalRows"
            @change="onPageChange($event)"
          ></b-pagination>
        </div>
      </b-card-text>
    </b-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>

    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="modal-Add-Open"
      hide-footer
      :title="
        ConsoleBookDetails.CBType == 'add'
          ? 'Add Console Booking'
          : 'Update Console Booking'
      "
    >
      <b-row>
        
        <b-col cols="3" class="mt-2">
          <label for="blType">
            
            Branch :
            <span class="error">*</span>
            <!-- <span class="error" v-if="ConsoleBookDetails.booking_for">{{ ConsoleBookDetails.booking_for }}</span> -->
          </label>
          <model-list-select
            :isDisabled="
              $sessionsStorage.get('cust_username') == 'Admin' ||
              $sessionsStorage.get('cust_username') == 'admin' ||
              $sessionsStorage.get('cust_username') == 'shankarrawat' ||
              $sessionsStorage.get('cust_username') == 'vijaysharma' ||
              $sessionsStorage.get('cust_username') == 'rathishnair' ||
              $sessionsStorage.get('cust_username') == 'aaryav'
                ? false
                : true
            "
            :list="BranchList"
            option-value="pickupId"
            option-text="pickupLocation"
            class="ml-2"
            v-model="ConsoleBookDetails.fk_branch_id"
            placeholder="Select Branch"
          ></model-list-select>
          <span class="error" v-if="!ConsoleBookDetails.fk_branch_id">
            {{ errorCBDetails.fk_branch_id }}
          </span>
        </b-col>
        <b-col cols="3" class="mt-2"> 
          <label for="fk_enq_price_id">
            Enquiry Pricing No. :
            <span class="error">*</span>
          </label>
          <model-list-select
                :list="$store.getters['enqPriceEngineDropdown/getAllEnqPriceDDList']"
                id="fk_enq_price_id"
                v-model="ConsoleBookDetails.fk_enq_price_id"
                option-value="value"
                option-text="label"
                placeholder="Select Pricing No"
                @input="updateBookingRes(ConsoleBookDetails.fk_enq_price_id)"
              ></model-list-select>
          <span class="error" v-if="!ConsoleBookDetails.fk_enq_price_id">
            {{ errorCBDetails.fk_enq_price_id }}
          </span>

     
        </b-col>
        <b-col cols="3" class="mt-2">
          <label for="bkgType">Booking Type</label>
          <model-list-select
            :list="BookingTypeList"
            v-model="ConsoleBookDetails.bookingType"
            option-value="bkgval"
            option-text="bkgtxt"
            placeholder="Select Booking Type"
          ></model-list-select>
          <span class="error" v-if="!ConsoleBookDetails.bookingType">
            {{ errorCBDetails.bookingType }}
          </span>
        </b-col>
        <b-col cols="3" class="mt-2">
          <label for="blType">
            Booking No. :
            <span class="error">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="ConsoleBookDetails.booking_no"
            type="text"
            placeholder="Enter Booking No"
          ></b-form-input>
          <span class="error" v-if="!ConsoleBookDetails.booking_no">
            {{ errorCBDetails.booking_no }}
          </span>
        </b-col>
       
        <b-col cols="3" class="mt-2" v-if="ConsoleBookDetails.booking_for='Client'">
          <label for="blType">
            Client Name :
            <span class="error">*</span>
          </label>
          <model-list-select
            :list="clientMaster"
            option-value="clientId"
            option-text="clientName"
            class="ml-2"
            v-model="ConsoleBookDetails.fk_client_id"
            placeholder="Select Client Name"
          ></model-list-select>
          <span class="error" v-if="!ConsoleBookDetails.fk_client_id">
            {{ errorCBDetails.fk_client_id }}
          </span>
        </b-col>
        <b-col cols="3" class="mt-2" v-if="ConsoleBookDetails.booking_for='Agent'">
          <label for="agentName">
            Agent Name :
            <span class="error">*</span>
          </label>
          <model-list-select
            :list="$store.getters['common/getAllAgentColoaderList']"
            option-value="agntColoaderId"
            option-text="agentName"
            class="ml-2"
            v-model="ConsoleBookDetails.fk_agent_id"
            placeholder="Select Agent Name"
          ></model-list-select>
          <span class="error" v-if="!ConsoleBookDetails.fk_agent_id">
            {{ errorCBDetails.fk_agent_id }}
          </span>
        </b-col>
        <b-col cols="3" class="mt-2">
          <label for="blType">
            Shipping Line :
            <span class="error">*</span>
          </label>
          <model-list-select
            :list="ShippingLineList"
            option-value="shippingId"
            option-text="shippingLine"
            class="ml-2"
            v-model="ConsoleBookDetails.fk_shippingline_id"
            placeholder="Select Shipping Line"
          ></model-list-select>
          <span class="error" v-if="!ConsoleBookDetails.fk_shippingline_id">
            {{ errorCBDetails.fk_shippingline_id }}
          </span>
        </b-col>

       

        <b-col cols="3" class="mt-2" v-if="ConsoleBookDetails.bookingType === 'ON CONTRACT'"> 
          <label for="blType">
            Contract No. :
            <span class="error">*</span>
          </label>
          <!-- <b-form-input
            :formatter="capitalizeAll"
            v-model="ConsoleBookDetails.contract_no"
            type="text"
            placeholder="Enter Contract No"
          ></b-form-input> -->
          <model-list-select
                :list="$store.getters['common/getAllMultiContractList']"
                id="contract_no"
                v-model="ConsoleBookDetails.contract_no"
                option-value="text"
                option-text="text"
                placeholder="Select Contract No"
                @input="changeContractNo(ConsoleBookDetails.contract_no)"
              ></model-list-select>
          <span class="error" v-if="!ConsoleBookDetails.contract_no && ConsoleBookDetails.bookingType === 'ON CONTRACT'">
            {{ errorCBDetails.contract_no }}
          </span>
        </b-col>
      
        <b-col cols="12" class="text-center">
          <b-button
            :disabled="isCBdisabled || !ConsoleBookDetails.booking_no"
            class="mt-3 sm"
            variant="success"
            v-if="ConsoleBookDetails.booking_no != ''"
            @click="submitConsoleBooking"
            >{{ buttonTxt }}</b-button
          >
          <b-button class="mt-3 sm" variant="outline-danger" @click="closeModalAdd"
            >Close</b-button
          >
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="modal-AddOther-Open"
      hide-footer
      :title="'Add Other Details'"
    >
      <b-row>
        <!-- <b-col cols="6"
        ></b-col>-->
        <!-- {{ booking_type_status}} -->

        <b-col cols="6" v-if="CBValidityDetails.is_booing_response==1">
          <label>Booking No:<span class="error">*</span></label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="CBValidityDetails.booking_no"
            type="text"
            placeholder="Enter Booking No"
          />
           <span class="error" v-if="!CBValidityDetails.booking_no">
            {{ errorCBValidityDetails.booking_no }}
          </span>
        </b-col>
        <b-col cols="6">
          <b-button variant="primary" @click="openContractModal()" id="addButtonLoader" size="sm"  class="ml-2">Add Contract</b-button>
          <b-button variant="primary" @click="openVesselModal()" id="addButtonLoader" size="sm" class="ml-2">Add Vessel</b-button>
              
        </b-col>
        <b-col cols="12" v-if="booking_type_status == '1'">
          <table class="table table-sm table-bordered mt-2">
            <tbody style="background: white">
              <tr v-if="CONTAINERCOUNTArr.length > 0">
                <th scope="col" style="width: 5px">SN.</th>
                <th scope="col" style="width: 200px">CONTAINER TYPE</th>
                <th scope="col" style="width: 180px">CONTAINER COUNT</th>
                <th scope="col" style="width: 180px">CURRENCY</th>
                <th scope="col" style="width: 180px">BUYING OCEAN FREIGHT</th>
                <th scope="col" style="width: 5px">
                  Actions
                  <b-button
                    :disabled="CBValidityDetails_inputFlag"
                    @click="addContainerCount()"
                    size="sm"
                  >
                    <i class="fa fa-plus-circle ml-1"></i>
                  </b-button>
                </th>
              </tr>
              <tr v-for="(item, index) in CONTAINERCOUNTArr" :key="index">
                <th scope="row">{{ index + 1 }}.</th>
                <td>
                  <model-list-select
                    :isDisabled="CBValidityDetails_inputFlag"
                    :list="containerList"
                    v-model="item.cont_type"
                    option-value="value"
                    option-text="text"
                    placeholder="Select Container Type"
                  ></model-list-select>
                  <span class="error" v-if="item.cont_type_err ? true : false">{{
                    item.cont_type_err
                  }}</span>
                </td>
                <td>
                  <b-form-input
                    :disabled="CBValidityDetails_inputFlag"
                    :formatter="capitalizeAll"
                    v-model="item.cont_count"
                    type="number"
                    placeholder="Enter Container Count"
                  ></b-form-input>
                  <span class="error" v-if="item.cont_count_err ? true : false">{{
                    item.cont_count_err
                  }}</span>
                </td>
                <td>
                  <model-list-select
                    :isDisabled="CBValidityDetails_inputFlag"
                    :list="CurrencyList"
                    v-model="item.currency"
                    option-value="currency_id"
                    option-text="currencyCode"
                    placeholder="Select Currency"
                  ></model-list-select>
                  <span class="error" v-if="item.currency_err ? true : false">{{
                    item.currency_err
                  }}</span>
                </td>
                <td>
                  <b-form-input
                    :disabled="CBValidityDetails_inputFlag"
                    :formatter="capitalizeAll"
                    v-model="item.buying_ocean_freight"
                    type="number"
                    placeholder="Enter BUYING OCEAN FREIGHT"
                  ></b-form-input>
                  <span
                    class="error"
                    v-if="item.buying_ocean_freight_err ? true : false"
                    >{{ item.buying_ocean_freight_err }}</span
                  >
                </td>
                <td>
                  <b-button
                    v-if="index > 0"
                    size="sm"
                    @click="removeContainerCount(index)"
                    :disabled="CBValidityDetails_inputFlag"
                  >
                    <i class="fa fa-minus-circle" aria-hidden="true"></i>
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>
        <b-col cols="6" class="mt-2" v-if="booking_type_status == '0'">
          <label for="blType">
            CONTAINER TYPE :
            <span class="error">*</span>
          </label>
          <multi-select
            :isDisabled="CBValidityDetails_inputFlag"
            :options="containerList"
            :selected-options="items"
            v-model="CBValidityDetails.containerTypeDet"
            placeholder="Select Container Type"
            :multiple="true"
            @select="SelectContainerType"
          ></multi-select>
          <span class="error" v-if="!CBValidityDetails.containerTypeDet">
            {{ errorCBValidityDetails.containerTypeDet }}
          </span>
        </b-col>
        <b-col cols="3" class="mt-2" v-if="booking_type_status == '0'"></b-col>
        <b-col cols="3" class="mt-2" v-if="booking_type_status == '0'"></b-col>
        <!-- <b-col cols="3" class="mt-2"></b-col> -->
        <b-col cols="3" class="mt-2">
          <label for="blType">
            Validity Start. :
            <span class="error">*</span>
            <br />
          </label>
          <date-picker
            :disabled="CBValidityDetails_inputFlag"
            :format="selectDateFormat"
            lang="en"
            :minute-step="1"
            name="validity_start"
            id="validity_start"
            v-model="CBValidityDetails.validity_start"
          ></date-picker>
          <span class="error" v-if="!CBValidityDetails.validity_start">
            {{ errorCBValidityDetails.validity_start }}
          </span>
        </b-col>
        <b-col cols="3" class="mt-2">
          <label for="blType">
            Validity End. :
            <span class="error">*</span>
            <br />
          </label>
          <date-picker
            :disabled="CBValidityDetails_inputFlag"
            :format="selectDateFormat"
            lang="en"
            :minute-step="1"
            name="validity_end"
            id="validity_end"
            v-model="CBValidityDetails.validity_end"
          ></date-picker>
          <span class="error" v-if="!CBValidityDetails.validity_end">
            {{ errorCBValidityDetails.validity_end }}
          </span>
        </b-col>
        <b-col cols="3" class="mt-2">
          <label for="blType">
            Vessel Sail Date :
            <span class="error">*</span>
            <br />
          </label>
          <date-picker
            :disabled="CBValidityDetails_inputFlag"
            :format="selectDateFormat"
            lang="en"
            :minute-step="1"
            name="vessel_sale_start_date"
            id="vessel_sale_start_date"
            v-model="CBValidityDetails.vessel_sale_start_date"
            @input="ChangeVessalesEndDate(CBValidityDetails.vessel_sale_start_date)"
          ></date-picker>
          <span class="error" v-if="!CBValidityDetails.vessel_sale_start_date">{{
            errorCBValidityDetails.vessel_sale_start_date
          }}</span>
        </b-col>
        <b-col cols="3" class="mt-2">
          <label for="blType">Last Date Of Cancellation</label>
          <date-picker
            disabled
            :format="selectDateFormat"
            lang="en"
            :minute-step="1"
            name="vessel_sale_end_date"
            id="vessel_sale_end_date"
            v-model="CBValidityDetails.vessel_sale_end_date"
          ></date-picker>
          <span class="error" v-if="!CBValidityDetails.vessel_sale_end_date">
            {{ errorCBValidityDetails.vessel_sale_end_date }}
          </span>
        </b-col>
        <!-- <b-col cols="3" class="mt-2">
          <label>
            SI Cutoff Date & Time
            <span class="error">*</span>
          </label>
          <date-picker
            :disabled="CBValidityDetails_inputFlag"
            lang="en"
            name="SICutOff"
            id="SICutOff"
            type="datetime"
            format="YYYY-MM-DD hh:mm a"
            :minute-step="1"
            v-model="CBValidityDetails.sicutoff"
          ></date-picker>
          <span class="error" v-if="!CBValidityDetails.sicutoff">
            {{ errorCBValidityDetails.sicutoff }}
          </span>
        </b-col> -->
      
        <!--<b-col cols="3" class="mt-2">
          <label>
            Tentative Vessel ETA
            <span class="error">*</span>
          </label>
          <date-picker
            :disabled="CBValidityDetails_inputFlag"
            lang="en"
            name="vesselEta"
            id="vesselEta"
            type="datetime"
            format="YYYY-MM-DD hh:mm a"
            :minute-step="1"
            v-model="CBValidityDetails.vesselEta"
          ></date-picker>
          <span class="error" v-if="!CBValidityDetails.vesselEta">
            {{ errorCBValidityDetails.vesselEta }}
          </span>
        </b-col>
        <b-col cols="3" class="mt-2">
          <label>
            Tentative Vessel ETD
            <span class="error">*</span>
          </label>
          <date-picker
            :disabled="CBValidityDetails_inputFlag"
            lang="en"
            name="vesselEtd"
            id="vesselEtd"
            type="datetime"
            format="YYYY-MM-DD hh:mm a"
            :minute-step="1"
            v-model="CBValidityDetails.vesselEtd"
          ></date-picker>
          <span class="error" v-if="!CBValidityDetails.vesselEtd">
            {{ errorCBValidityDetails.vesselEtd }}
          </span>
        </b-col>
        <b-col cols="3" class="mt-2">
          <label>
            Vessel Name
            <span class="error">*</span>
          </label>
          <b-form-input
            :disabled="CBValidityDetails_inputFlag"
            :formatter="capitalizeAll"
            name="vesselName"
            id="vesselName"
            v-model="CBValidityDetails.vesselName"
          ></b-form-input>
          <span class="error" v-if="!CBValidityDetails.vesselName">
            {{ errorCBValidityDetails.vesselName }}
          </span>
        </b-col>
        <b-col cols="3" class="mt-2">
          <label>
            Voyage No.
            <span class="error">*</span>
          </label>
          <b-form-input
            :disabled="CBValidityDetails_inputFlag"
            :formatter="capitalizeAll"
            name="voyageNo"
            id="voyageNo"
            v-model="CBValidityDetails.voyageNo"
          ></b-form-input>
          <span class="error" v-if="!CBValidityDetails.voyageNo">
            {{ errorCBValidityDetails.voyageNo }}
          </span>
        </b-col> -->

        <b-col cols="3" class="mt-2">
          <label for="blType">
            POR :
            <span class="error">*</span>
          </label>
          <model-list-select
            :isDisabled="CBValidityDetails_inputFlag"
            @input="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
            @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
            :list="finalAllPlaceDataPOR"
            v-model="CBValidityDetails.fk_por_id"
            option-value="pickupId"
            option-text="pickupLocation"
            placeholder="Select Place of Receipt"
          ></model-list-select>
          <span class="error" v-if="!CBValidityDetails.fk_por_id">
            {{ errorCBValidityDetails.fk_por_id }}
          </span>
        </b-col>

        <b-col cols="3" class="mt-2">
          <label for="blType">
            POD :
            <span class="error">*</span>
          </label>
          <model-list-select
            :isDisabled="CBValidityDetails_inputFlag"
            @input="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
            @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
            :list="finalAllPlaceDataPOD"
            v-model="CBValidityDetails.fk_pod_id"
            option-value="pickupId"
            option-text="pickupLocation"
            placeholder="Select Port of Discharge"
          ></model-list-select>
          <span class="error" v-if="!CBValidityDetails.fk_pod_id">
            {{ errorCBValidityDetails.fk_pod_id }}
          </span>
        </b-col>

        <b-col cols="3" class="mt-2">
          <label for="blType">
            POL :
            <span class="error">*</span>
          </label>
          <model-list-select
            :isDisabled="CBValidityDetails_inputFlag"
            @input="getLocationList($event, 'All', 'finalAllPlaceDataLP')"
            @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataLP')"
            :list="finalAllPlaceDataLP"
            v-model="CBValidityDetails.fk_pol_id"
            option-value="pickupId"
            option-text="pickupLocation"
            placeholder="Select Load Port"
          ></model-list-select>
          <span class="error" v-if="!CBValidityDetails.fk_pol_id">
            {{ errorCBValidityDetails.fk_pol_id }}
          </span>
        </b-col>
        <b-col cols="3" class="mt-2">
          <label for="blType">
            Vessel Name :
            <span class="error">*</span>
          </label>
          <!-- {{ CBValidityDetails }} -->
          <model-list-select class="ml-1" :list="$store.getters['common/getAllContractBasedVesselList']"
            id="vessel_name" v-model="CBValidityDetails.fk_ccbm_id" option-value="value" option-text="label"
            placeholder="Select Vessel Name" @input="getAllContractBasedVesselList(CBValidityDetails.fk_ccbm_id)" :style="{
              borderColor:
                !CBValidityDetails.fk_ccbm_id && errorCBValidityDetails.fk_ccbm_id
                  ? 'red'
                  : '',
            }" />
          <span class="error" v-if="!CBValidityDetails.fk_ccbm_id && errorCBValidityDetails.fk_ccbm_id">
            {{ errorCBValidityDetails.fk_ccbm_id }}
          </span>
        </b-col>

        <b-col cols="12" class="mt-2">
          <label for="blType">
            Remark :
            <span class="error">*</span>
          </label>
          <b-form-textarea
            :disabled="CBValidityDetails_inputFlag"
            :formatter="capitalizeAll"
            id="remark"
            name="remark"
            v-model="CBValidityDetails.remark"
          ></b-form-textarea>
          <span class="error" v-if="!CBValidityDetails.remark">
            {{ errorCBValidityDetails.remark }}
          </span>
        </b-col>
        <b-col cols="12" class="mt-2">
          <label for="blType">
            Validity Doc. :
            <span class="error">*</span>
          </label>
          <!-- <Single-Upload
            :disabled="CBValidityDetails_inputFlag"
            :documentName="'BOOKING_ORDER_'"
            :otherDocName="'BOOKING_ORDER_'"
            :folderName="'Console_Booking_Doc'"
            :accept="'*'"
            :assign_no="`Console_Booking_Doc`"
            :multiple="true"
            v-model="singleUpload"
            :state="Boolean(singleUpload)"
            :fileAllModuleId="allModuleIdProp"
          ></Single-Upload> -->
          <multi-file-uploader
          :disabled="CBValidityDetails_inputFlag"
                          :style="`height: 79px;    background: darkgray;    width: 300px;`"
                          :documentName="'BOOKING_ORDER_'"
                          :otherDocName="'BOOKING_ORDER_'"
                          :folderName="'Console_Booking_Doc'"
                          :accept="'*'"
                          :assign_no="'Console_Booking_Doc'"
                          :multiple="true"
                          v-model="singleUpload"
                          :state="Boolean(singleUpload)"
                          :fileAllModuleId="''"
                        ></multi-file-uploader>
          <!-- <b-form-file
            style="height: 100px"
            :disabled="CBValidityDetails_inputFlag"
            v-model="CBValidityDetails.validity_doc"
            name="validity_doc"
            id="validity_doc"
            @input="onFileChangeBlDraft"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            multiple
          ></b-form-file> -->
          <!-- this.CBValidityDetails.validity_doc -->
          <!-- :state="Boolean(CBValidityDetails.validity_doc)" -->
          <!-- <md-input-container>
            <md-file
              :disabled="CBValidityDetails_inputFlag"
              size="sm"
              name="validity_doc"
              id="validity_doc"
              v-model="CBValidityDetails.validity_doc"
              @selected="onFileChangeBlDraft('CBValidityDoc', 0)"
              multiple
            ></md-file>
          </md-input-container>-->
          <span class="error" v-if="validity_doc_error"> Document is Required </span>
          <span class="error" v-if="!ConsoleBookDetails.validity_doc">
            {{ errorCBValidityDetails.validity_doc }}
          </span>
          <br />
          <b
            v-if="
              CBValidityDetails.validity_doc != '' &&
              CBValidityDetails.validity_doc != undefined &&
              CBValidityDetails.validity_doc != null
            "
          >
            <!-- row5.item.validity_docArr != undefined
                    ? sanitizedArray(row5.item.validity_docArr)
                    : [] -->
            <!-- {{ CBValidityDetails.validity_doc }} -->
            <span v-if="CBValidityDetails.validity_doc">
              <b v-if="CBValidityDetails.validity_doc.split(',').length > 0">
                <span
                  v-for="(item_doc, index_doc) in sanitizedArray(CBValidityDetails.validity_doc.split(','))"
                  :key="index_doc"
                >
                  <a
                    v-if="item_doc != ''"
                    href="javascript:void(0)"
                    @click="PrintValidity_Doc(item_doc)"
                    >View Document - {{ index_doc + 1 }}</a
                  >
                  <br />
                </span>
              </b>
              <b v-else>
                <a
                  v-if="
                    CBValidityDetails.validity_doc != '' &&
                    CBValidityDetails.validity_doc != undefined &&
                    CBValidityDetails.validity_doc != null
                  "
                  href="javascript:void(0)"
                  @click="PrintValidity_Doc(CBValidityDetails.validity_doc)"
                  >View Document</a
                >
              </b>
            </span>
          </b>
        </b-col>
        <!-- {{ isOtherCBdisabled }} -->
        <b-col cols="12" class="text-center">
          <!-- :disabled="isOtherCBdisabled || CBValidityDetails.booking_no==null || CBValidityDetails.booking_no==undefined || CBValidityDetails.booking_no=='null' || CBValidityDetails.booking_no=='undefined' || CBValidityDetails.booking_no=='' || !CBValidityDetails.booking_no" -->
            
          <b-button
            class="mt-3 sm"
            variant="success"
            v-if="CBValidityDetails.booking_id != ''|| !CBValidityDetails.booking_no"
            @click="submitOtherConsoleBooking"
            >{{ buttonTxt }}</b-button
          >
          <b-button class="mt-3 sm" variant="outline-danger" @click="closeModalAddOther"
            >Close</b-button
          >
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="modal-CancelBooking-conf"
      ref="modal-CancelBooking-conf"
      title="Cancel Console Booking Confirmation"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <h1 v-if="MessageFlag == true">{{ Message }}</h1>
      <form ref="form" v-if="MessageFlag == false">
        <b-form-group
          label="Reason for Cancel Console Booking"
          label-for="name-input"
          invalid-feedback="Name is required"
        >
          <b-form-textarea
            :formatter="capitalizeAll"
            rows="5"
            id="name-input"
            v-model="closingReasontxt"
            required
            v-on:keyup="closingReason"
          ></b-form-textarea>
          <span class="error">{{ closingReasontxterr }}</span>
        </b-form-group>
      </form>
      <b-button
        v-if="MessageFlag == false"
        :disabled="iscloseCBdisabled ? false : true"
        variant="success"
        @click="updateCancelBooking"
        >Confirm & Close Billing</b-button
      >
      <b-button @click="closeCancelBookingModal" variant="danger" class="pull-right"
        >Cancel</b-button
      >
    </b-modal>

    <b-modal ref="ApprovalRequestModal" no-close-on-esc no-close-on-backdrop title="Console Booking Approval Request" :size="showRequestCBType==2?'xs':'xl'" hide-footer
        @hidden="closeApprovalRequestModal">
        <!-- Modal content remains the same -->
        <b-row class="mb-2" v-if="showRequestCBType==2">
          <b-col cols="12">
              <label for="delay_reason">Reason : <span class='error'>*</span></label>
              <model-list-select 
              :list="delayReasonList" 
              id="delay_reason"
              v-model="delay_reason" 
              option-value="value" 
              option-text="label"
              placeholder="Select Reason" />
          </b-col>
        
          <b-col cols="12" v-if="delay_reason=='Delay at Shipping Line'">
            <label for="delay_reason_remark">Remark : *</label>
            <b-form-input id="delay_reason_remark" placeholder="Pls Enter Remark"  type="text" v-model="delay_reason_remark" />
        </b-col>
        </b-row>
        <b-row class="mb-2" v-if="showRequestCBType==1">
          <b-col cols="12">
            <b-table
            show-empty
            stacked="md"
            responsive
            :items="CBApprovalLogList"
            :fields="CBApprovalLogFields"
            primary-key="clientId"
            class="position-relative"
            :per-page="pagination.perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
          >
            <template slot="SN" slot-scope="row0">
              <span>{{
                row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
              }}</span>
            </template>
            
          </b-table>
          </b-col>
        
        </b-row>
        <b-row class="justify-content-end">
            <b-button v-if="showRequestCBType==2" :disabled="delay_reason?false:true" variant="primary" style="font-size: 0.675rem" @click="sendApprovalRequest">Send</b-button>
            <b-button variant="secondary" style="font-size: 0.675rem" @click="closeApprovalRequestModal" class="ml-2">Cancel</b-button>
        </b-row>
    </b-modal>
    <!-- Added By Priyanshu SIngh End -->
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import { ModelListSelect, MultiSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import CustomLoader from "../common/customLoader.vue";
import MultiFileUploader from "../common/MultiFileUploader.vue";
import { DateFormat, selectDateFormat, wordWrap } from "../../helper/filters";
import {
  globalPermissionStatus,
  lastVisitPage,
  GlobalGetLocation,
} from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import MasterService from "../../services/MasterService.js";
import BRFCard from "../common/brfCard.vue";
import NodeLockPannelService from "../../services/NodeLockPannelService.js";
import ToggleBRFSwitch from "../Pricing/ToggleBRFSwitch.vue";
import BookingTrack from "../consoleBooking/bookingTrack.vue";

// import SingleUpload from "../common/singleUpload.vue";

export default {
  beforeMount() {
    this.getCurrentLastDate();
    lastVisitPage(this.$router.history.current.fullPath);
    let viewmultiBill_allModuleID = this.$sessionsStorage.get(
      "viewmultiBill_allModuleID"
    );
    let multibillingSeries = this.$sessionsStorage.get("viewmultiBill_billingSeries");
    // if (globalPermissionStatus("Accounts")) {
    this.$store.dispatch(
      "setCurrentRoute",
      "/viewBillingDetails/viewMultiBillingDetails"
    );
    this.$store.dispatch(
      "common/setAllMultiContractList",
      JSON.stringify({
        itemCode: "GET_MULTI_ContractLIST_Data",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceDDList",
      JSON.stringify({
        itemCode: "getEngPricingList",
      })
    );
    this.$store.dispatch("common/setAllContractList", {
      filter: "ContractList",
      active: "all",
      isAll: 1,
      cb_is_active: 1,
      cb_is_deleted: 0,
      isSelectedColumn: 1,
    }),
    this.$store.dispatch("common/setAllContractBasedVesselList", {
      filter: "ContractVesselList",
      active: "all",
      isAll: 0,
      ccbm_is_active: 1,
      ccbm_is_deleted: 0,
      isSelectedColumn: 0,
      // isSelectedColumn: 1,
      fk_cb_id: this.ConsoleBookDetails.fk_contarct_id,
      is_withoutcb: 1,
    });
    this.$store.dispatch("common/setAllAgentColoaderList");
    if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
      this.fetchLastPage(this.lastVisitPage);
    } else {
      this.viewBookingConsoleList("0", "1", "1");
    }
    // } else {
    //   this.$router.push({
    //     path: "/dashboard",
    //   });
    // }
  },

  data() {
    return {
      contractModal: {
        cb_id: 0,
        cb_contarct_no: "",
        contract_name: "",
        contract_description: "",
        start_date: "",
        end_date: "",
      },
      contractError: ["Please Enter Contract No"],
      errorContractList: {
        cb_contarct_no: "",
      },
      contractDisabled: false,
      vesselModal: {
        ccbm_id: '',
        fk_contract_id: '',
        vessel_name: '',
        vessel_voyage_no: '',
        vessel_sail_date: '',
        ra_number: "",
      },
      vesselError: ["Please Enter Vessel Name","Please Enter Voyage No", "Please Enter SOB Date"],
      errorVesselList: {
        vessel_name: "",
        vessel_voyage_no: "",
        vessel_sail_date: "",
      },
      showRequestCBType:1,
      requestCBItem:null,
      delay_reason:"",
      delay_reason_remark:"",
      delayReasonList: [
            { value: '', label: 'Select reason' },
            { value: 'Delay at Shipping Line', label: 'Delay at Shipping Line' },
            { value: 'Delay at Pridel Booking Team', label: 'Delay at Pridel Booking Team' }
        ],
      //Added By Priyanshu Singh Console Booking Variable Start
      // common_item:{},
      singleUpload: [],
      validity_doc_error: false,
      ExcelBtnName: "Export as Excel",
      validateCONC: true,
      CONTAINERCOUNTArr: [
        {
          cont_type: "",
          cont_count: "",
          currency: "1",
          buying_ocean_freight: "",

          cont_type_err: "",
          cont_count_err: "",
          currency_err: "",
          buying_ocean_freight_err: "",
        },
      ],
      CurrencyList: [],
      booking_type_status: "",
      Message: "",
      MessageFlag: false,
      booking_no: "",
      contract_no: "",
      fk_contarct_id: "",
      booking_id: "",
      iscloseCBdisabled: false,
      closingReasontxt: "",
      closingReasontxterr: "",
      buttonTxt: "Save",
      isCBdisabled: false,
      ConsoleBookData: [],
      finalAllPlaceDataPOR: [],
      finalAllPlaceDataPOD: [],
      finalAllPlaceDataLP: [],
      containerList: [],
      selectDateFormat,
      ConsoleBookDetails: {
        CBType: "add",
        booking_no: "",
        contract_no: "",
        fk_contarct_id:"",
        fk_client_id: "",
        fk_shippingline_id: "",
        fk_branch_id: "",
        booking_id: "",
        bookingType: "",
        fk_enq_price_id:"",
        vesselEtd:"",
        fk_agent_id:"",
        booking_for: "",
        fk_pol_id:"",
        fk_por_id:"",
        fk_pod_id:"",
        fk_ccbm_id:"",
        remark:"",
        is_booing_response:0,
      },
      errorCBDetails: {
        booking_no: "",
        contract_no: "",
        fk_client_id: "",
        // fk_agent_id:"",
        fk_shippingline_id: "",
        fk_branch_id: "",
        bookingType: "",
        // fk_enq_price_id:"",
      },
      arrayErrorCBDetails: [
        {
          booking_no: "Please Enter Booking number",
          contract_no: "Please Enter Contract number",
          fk_client_id: "Please Select Client",
          // fk_agent_id: "Please Select Agent",
          fk_shippingline_id: "Please Select Shipping Line",
          fk_branch_id: "Please Select Branch",
          bookingType: "Please Select Booking Type",
          // fk_enq_price_id:"Please Select Enquiry Pricing No",
        },
      ],
      docURL: URL_BASE_DOC,
      isOtherCBdisabled: false,
      CBValidityData: [],
      items: [],
      CBValidityDetails_inputFlag: false,
      CBValidityDetails: {
        remark: "",
        fk_pol_id: "",
        fk_pod_id: "",
        fk_por_id: "",
        containerTypeDet: [],
        validity_end: "",
        validity_start: "",
        vessel_sale_start_date: "",
        vessel_sale_end_date: "",
        sicutoff: "",
        vesselEta: "",
        vesselEtd: "",
        voyageNo: "",
        vesselName: "",
        validity_doc: "",
        fk_ccbm_id:"",
        booking_id: "",
        multipleContainerType: [],
        multipleContainerTypeId: [],
        booking_type_status: "",
        container_count_arr: "",
        booking_no: "",
        is_booing_response: 0,
      },
      errorCBValidityDetails: {
        // remark: "",
        booking_no: "",
        fk_pol_id: "",
        fk_pod_id: "",
        fk_por_id: "",
        // containerTypeDet: "",
        validity_end: "",
        validity_start: "",
        vessel_sale_start_date: "",
        vessel_sale_end_date: "",
        // sicutoff: "",
        // vesselEta: "",
        // vesselEtd: "",
        // voyageNo: "",
        // vesselName: "",
        fk_ccbm_id: "",
        validity_doc: "",
      },
      arrayErrorCBValidityDetails: [
        {
          // remark: "Please Enter Remark",
          booking_no: "Please Enter Booking number",
          fk_pol_id: "Please Select POL",
          fk_pod_id: "Please Select POD",
          fk_por_id: "Please Select POR",
          // containerTypeDet: "Please Select Container Type",
          validity_end: "Please Enter Validity End Date",
          validity_start: "Please Enter Validity Start Date",
          vessel_sale_start_date: "Please Enter Vessel Start Date",
          vessel_sale_end_date: "Please Enter Vessel End Date",
          // sicutoff: "Please Enter SI Cutoff Date & Time",
          // vesselEta: " Please Enter Vessel ETA",
          // vesselEtd: " Please Enter Vessel ETD",
          // voyageNo: " Please Enter Vessel Voyage No",
          // vesselName: "Please Enter Vessel Name",
          fk_ccbm_id: "Please Enter Vessel Name",
          validity_doc: "Please Select Document",
        },
      ],
      txtMSG: "",
      isCheckAll: false,
      AllBookingNo_ids: [],
      AllBookingNo_Series: [],
      consoBooking: [],
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      openRight: "right",
      showCal: false,
      showDash: false,
      dateRange: {
        startDate: "",
        endDate: "",
      },
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      clientIdFilter: "",
      agentIdFilter:"",
      BookingNoFilter: "",
      BRFNoFilter:"",
      ShippingLineFilter: "",
      BranchFilter: "",
      BookingStatusFilter: "4",
      PORfilter: "",
      PODfilter: "",
      POLfilter: "",
      fk_contract_idFilter: "",
      fk_ccbm_idFilter: "",
      clientMaster: [],
      BookingStatusList: [
        {
          inv: "1",
          int: "RELEASED",
        },
        {
          inv: "2",
          int: "UNRELEASED",
        },
        {
          inv: "3",
          int: "CANCELLED",
        },
        {
          inv: "4",
          int: "All",
        },
      ],
      BookingTypeList: [
        {
          bkgval: "ON SPOT",
          bkgtxt: "ON SPOT",
        },
        {
          bkgval: "WEB QUOTE",
          bkgtxt: "WEB QUOTE",
        },
        {
          bkgval: "ON CONTRACT",
          bkgtxt: "ON CONTRACT",
        },
        {
          bkgval: "NOT APPLICABLE",
          bkgtxt: "NOT APPLICABLE",
        },
      ],
      ShippingLineList: [],
      BranchList: [],
      validate: false,
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      totalRows: 1000000000000000,
      currentPage: 1,
      perPage: 25,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      fields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "booking_no",
          mainkey: "booking_no",
          label: "Booking No.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "ClientName",
          mainkey: "ClientName",
          label: "Client Name",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "shippingLine",
          mainkey: "shippingLine",
          label: "Shipping Line",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "POD",
          mainkey: "POD",
          label: "Other Details",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "vessel_sale_start_date",
          mainkey: "vessel_sale_start_date",
          label: "DATE",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "mainSeries",
          mainkey: "mainSeries",
          label: "Sales Execution Assignment No.",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "BookingStatus",
          mainkey: "BookingStatus",
          label: "Booking Status",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "booking_id",
          mainkey: "booking_id",
          label: "Actions",
          sortable: true,
          sortDirection: "ASC",
        },
      ],
      isLoading: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      PaginationList: [
        {
          pagv: "25",
          pagt: "25",
        },
        {
          pagv: "50",
          pagt: "50",
        },
        {
          pagv: "75",
          pagt: "75",
        },
        {
          pagv: "100",
          pagt: "100",
        },
        {
          pagv: "125",
          pagt: "125",
        },
        {
          pagv: "150",
          pagt: "150",
        },
        {
          pagv: "175",
          pagt: "175",
        },
        {
          pagv: "200",
          pagt: "200",
        },
        {
          pagv: "225",
          pagt: "225",
        },
        {
          pagv: "250",
          pagt: "250",
        },
        {
          pagv: "275",
          pagt: "275",
        },
        {
          pagv: "300",
          pagt: "300",
        },
        {
          pagv: "325",
          pagt: "325",
        },
        {
          pagv: "350",
          pagt: "350",
        },
        {
          pagv: "375",
          pagt: "375",
        },
        {
          pagv: "400",
          pagt: "400",
        },
      ],
      PaginationCount: "",
      reload: true,
      CBApprovalLogList:[],
      generateExcel:0,
      pagination: {
        currentPage: 1,
        perPage: 25,
        pageOptions: [5, 10, 15],
      },
      CBApprovalLogFields:[
      {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "BookingType",
          mainkey: "BookingType",
          label: "Booking Type",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "BookingFor",
          mainkey: "BookingFor",
          label: "Booking For",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "BookingNo",
          mainkey: "BookingNo",
          label: "Booking No",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },

        {
          key: "ContractNo",
          mainkey: "ContractNo",
          label: "Contract No",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "ClientName",
          mainkey: "ClientName",
          label: "Client",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        {
          key: "CreatedBy",
          mainkey: "CreatedBy",
          label: "Created By",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        {
          key: "ApprovedBy",
          mainkey: "ApprovedBy",
          label: "Approved By",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        {
          key: "Status",
          mainkey: "Status",
          label: "Status",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        {
          key: "Reason",
          mainkey: "Reason",
          label: "Reason",
          sortable: true,
          sortDirection: "ASC",
          table: "F.",
        },
        {
          key: "Remark",
          mainkey: "Remark",
          label: "Remark",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "ApprovalRequestDate",
          mainkey: "ApprovalRequestDate",
          label: "Approval Request Date",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "ApprovalDate",
          mainkey: "ApprovalDate",
          label: "Approval/Reject Date",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "BookingCreatedAt",
          mainkey: "BookingCreatedAt",
          label: "Booking Date",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
      ]
      //Added By Priyanshu Singh  Console Booking Variable Start
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},
  destroyed() {},

  components: {
    // Loading,
    DatePicker,
    ModelListSelect,
    MultiSelect,
    DateRangePicker,
    // SingleUpload,
    CustomLoader,
    MultiFileUploader,
    BRFCard,
    ToggleBRFSwitch,
    BookingTrack,
  },

  computed: {},
  watch: {
    // containerTypeId: {
    //   handler: function(newVal, oldVal) {
    //     this.masterCallbackContainer(newVal);
    //   },
    //   deep: true
    // },
    clientIdFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.agentIdFilter ||
          this.ShippingLineFilter ||
          this.BookingNoFilter ||
          this.BRFNoFilter ||
          this.BranchFilter
        ) {
          this.BookingStatusFilter = "0";
        } else {
          this.BookingStatusFilter = "4";
        }
      },
      deep: true,
    },
    BookingNoFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.agentIdFilter ||
          this.ShippingLineFilter ||
          this.BookingNoFilter ||
          this.BRFNoFilter ||
          this.BranchFilter
        ) {
          this.BookingStatusFilter = "0";
        } else {
          this.BookingStatusFilter = "4";
        }
      },
      deep: true,
    },
    ShippingLineFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.agentIdFilter ||
          this.ShippingLineFilter ||
          this.BookingNoFilter ||
          this.BRFNoFilter ||
          this.BranchFilter
        ) {
          this.BookingStatusFilter = "0";
        } else {
          this.BookingStatusFilter = "4";
        }
      },
      deep: true,
    },
  },
  created() {
    eventBus.$on("fileuploaded", (file) => {
      // console.log("fileuploaded=>", file);
      this.CBValidityDetails.validity_doc = file;
    });
  },
  methods: {
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      // alert(firstDay);
      // alert(lastDay);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      //  alert(firstDay);
      // alert(lastDay);

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
      // alert(today);
    },
    wordWrap,
    previousSalesView() {
      window.history.go(-1);
    },
    ChangeVessalesEndDate(vessel_start_date) {
      const now = new Date(vessel_start_date);
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 11);
      this.CBValidityDetails.vessel_sale_end_date = today;
    },
    ChangeVessalesStartDate(vessel_start_date) {
      const now = new Date(vessel_start_date);
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      this.CBValidityDetails.vessel_sale_start_date = today;
    },
    sanitizedArrayBak(validity_doc) {
      
      // console.log("validity_doc=>", validity_doc);
      return validity_doc.map((item) => item.replace(/\n/g, ""));
    },
        sanitizedArray(validity_doc) {
      // Use the map method to replace "\n" with []
      const replacedArray = validity_doc.map((item) => {
        if (item === "\n") {
          return [];
        } else {
          return item;
        }
      });

      // Flatten the replacedArray and remove empty arrays
      const flattenedArray = replacedArray.reduce((acc, curr) => {
        if (Array.isArray(curr) && curr.length === 0) {
          return acc;
        }
        return acc.concat(curr);
      }, []);

      // console.log("validity_doc2 =>", flattenedArray);
      return flattenedArray;
    },
    PrintValidity_Doc(validity_doc) {
      this.openSignedDocument(`ASSIGNMENT_UPLOADS/Console_Booking_Doc/${validity_doc}`);
    },
    getAllContractBasedVesselList(ccbm_id) {
      let ContractVesselList = this.$store.getters["common/getAllContractBasedVesselList"].filter((x) => {
        return x.value == ccbm_id;
      });
      console.log('ContractVesselList=>', ContractVesselList)
      if (ContractVesselList.length > 0) {
        let vessel_name = ContractVesselList[0].vessel_name;
        let VesselList = this.$store.getters["common/getAllContractBasedVesselList"].filter((x) => {
          return x.vessel_name == vessel_name;
        });
        this.form.vessel_sale_start_date = ContractVesselList[0].vessel_sail_date;
        this.form.fk_ccbm_id = ContractVesselList[0].value,
        this.form.vesselName = ContractVesselList[0].vessel_name;
        this.form.voyageNo = ContractVesselList[0].vessel_voyage_no;
      }
    },
    openContractModal() {
      this.isLoading = false;
      this.$refs["Contract-modal"].show();
      this.contractDisabled = false;
      this.contractModal = {
        cb_id: 0,
        cb_contarct_no: "",
        contract_name: "",
        contract_description: "",
        start_date: "",
        end_date: "",
      };
      this.contractContainerArr = this.$store.getters['common/getAllContractBasedVesselList'];
    },
    hideContractModal() {
      this.$refs["Contract-modal"].hide();
      this.isLoading = false;
      this.contractDisabled = false;
      this.contractModal = {
        cb_id: 0,
        cb_contarct_no: "",
        contract_name: "",
        contract_description: "",
        start_date: "",
        end_date: "",
      };
    },
    validateContract() {
      let validate_new = true;
      Object.keys(this.errorContractList).map((x, index) => {
        if (this.contractModal[x] == "") {
          this.errorContractList[x] = this.contractError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    addContract() {
      this.validateContract();
      if (this.validate != false) {
        this.contractDisabled = true;
        this.contractModal.is_email_send = 1;

        NodeLockPannelService.saveContract(this.contractModal)
          .then((response) => {
            this.isLoading = false;
            const { statusText, status, data } = response;
            if (status == 200 && data) {
              this.$store.dispatch("common/setAllContractList", {
                filter: "ContractList",
                active: "all",
                isAll: 1,
                cb_is_active: 1,
                cb_is_deleted: 0,
                isSelectedColumn: 1,
              });
              if (data.data.cb_id != "" && data.data.cb_id != undefined) {
                if (data.status == true) {
                  this.alert.content = data.message;
                } else {
                  this.alert.content = data.message;
                  this.contractModal = {
                    cb_id: 0,
                    cb_contarct_no: "",
                    contract_name: "",
                    contract_description: "",
                    start_date: "",
                    end_date: "",
                  };
                }
              } else {
                this.alert.content = data.message;
              }
              this.hideContractModal();
              this.contractDisabled = false;
              this.$refs["addPop"].open();
            }
          })
          .catch((error) => {
            console.log("Catch on saveContract Error: ", error);
            this.isLoading = false;
          });
      }
    },
    validateVessel() {
      let validate_new = true;
      Object.keys(this.errorVesselList).map((x, index) => {
        if (this.vesselModal[x] == "") {
          this.errorVesselList[x] = this.vesselError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    
    getContractNo(fk_contract_id) {
      let ContractList = this.$store.getters["common/getAllContractList"].filter((x) => {
        return x.value == fk_contract_id;
      });
      if (ContractList.length > 0) {
        this.vesselModal.ra_number = ContractList[0].label;
        this.vesselModal.fk_contract_id = ContractList[0].value;
      }
    },
    addVesselVoyage() {
      this.validateVessel();
      if (this.validate != false) {
        this.contractDisabled = true;
        this.vesselModal.fk_contract_id = this.ConsoleBookDetails.fk_contarct_id;
        this.vesselModal.ra_number = this.ConsoleBookDetails.contract_no;
        NodeLockPannelService.saveContractVessel(this.vesselModal)
          .then((response) => {
            this.isLoading = false;
            const { statusText, status, data } = response;
            if (status == 200 && data) {

              if (data.data.ccbm_id != "" && data.data.ccbm_id != undefined) {
                this.$store.dispatch("common/setAllContractBasedVesselList", {
                  filter: "ContractVesselList",
                  active: "all",
                  isAll: 0,
                  ccbm_is_active: 1,
                  ccbm_is_deleted: 0,
                  isSelectedColumn: 0,
                  // isSelectedColumn: 1,
                  fk_cb_id: this.ConsoleBookDetails.fk_contarct_id,
                  is_withoutcb: 1,
                });
                if (data.status == true) {
                  this.alert.content = data.message;
                } else {
                  this.alert.content = data.message;
                  this.clearVesselModal();
                }
              } else {
                this.alert.content = data.message;
              }
              this.hideVesselModal();
              this.contractDisabled = false;
              this.$refs["addPop"].open();
            }
          })
          .catch((error) => {
            console.log("Catch on saveVessel Error: ", error);
            this.isLoading = false;
          });
      }
    },
    clearVesselModal() {
      this.vesselModal= {
        ccbm_id: '',
        fk_contract_id: '',
        vessel_name: '',
        vessel_voyage_no: '',
        vessel_sail_date: '',
        ra_number: "",
      };
    },
    openVesselModal() {
      this.clearVesselModal();
      this.$refs.vesselModalRef.show();
    },
    hideVesselModal() {
      this.clearVesselModal();
      this.$refs.vesselModalRef.hide();
    },
    AddBookingConsole(){
      this.$sessionsStorage.set("booking_resp_edit_type", 'Add');
      this.$router.push({
          path: "/pricing/upsert-new-booking-resp/0/0",
        });
    },
    AddBookingConsoleModal(type, item) {
      this.ConsoleBookDetails.CBType = type;
      if (type == "edit") {
        this.ConsoleBookDetails.CBType = type;
        this.ConsoleBookDetails.booking_no = item.booking_no;
        this.ConsoleBookDetails.contract_no = item.contract_no;
        this.ConsoleBookDetails.fk_contarct_id  = item.fk_contarct_id; 
        this.ConsoleBookDetails.fk_client_id = item.fk_client_id;
        this.ConsoleBookDetails.fk_agent_id = item.fk_agent_id;
        this.ConsoleBookDetails.booking_for = item.booking_for;
        this.ConsoleBookDetails.fk_shippingline_id = item.fk_shippingline_id;
        this.ConsoleBookDetails.fk_por_id = item.fk_por_id;
        this.ConsoleBookDetails.fk_pod_id = item.fk_pod_id;
        this.ConsoleBookDetails.fk_pol_id = item.fk_pol_id;

        this.ConsoleBookDetails.fk_branch_id = item.fk_branch_id;
        this.ConsoleBookDetails.fk_enq_price_id = item.fk_enq_price_id;
        this.ConsoleBookDetails.booking_id = item.booking_id;
        this.ConsoleBookDetails.bookingType = item.bookingType;
        this.buttonTxt = "Update";
        // this.getBookingConsoleDetails();
      }
      this.$refs["modal-Add-Open"].show();
    },
    ResetBookingConsole(item){
      if(item.is_subscription_tracking_status=="Yes"){
      let payload = {};
      payload = {
        excelId: "resetBookingConsole",
        booking_type:item.bookingType,
        booking_id:item.booking_id,
        booking_no:item.booking_no,
      };

      MasterService.ConsoleBooking(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          // console.log();
          if (status == 200 && data.CBSUBSRESETFLAG == 1) {
            // console.log("Success Reset= "+item.booking_no);
          }
          this.alert.content = data.CBSUBSRESETMSG;
          this.$refs["addPop"].open();
          this.viewBookingConsoleList("0", "1", "1");
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on ResetBookingConsole Error: ", error);
        });
      }
    },
    RemoveBookingConsole(type, item) {
      if (
        (type == "remove" || type == "recover" || type == "CANCELLED") &&
        item.booking_id != ""
      ) {
        let payload = {
          CBType: type,
          booking_id: item.booking_id,
          booking_no: item.booking_no,
          bookingactive_status_txt: item.bookingactive_status_txt,
          bookingactive_status: item.bookingactive_status,
        };
        // console.log("payload=>",payload);return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_ConsoleBooking/addConsoleBooking.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.booking_id != "" && data.booking_id != undefined) {
                if (data.find == 1) {
                  this.alert.content = data.MSG;
                } else {
                  this.alert.content = data.MSG;
                  this.ConsoleBookDetails.booking_id = "";
                  this.ConsoleBookDetails.booking_no = "";
                  this.ConsoleBookDetails.contract_no = "";
                  this.ConsoleBookDetails.fk_contarct_id = "";
                  this.ConsoleBookDetails.fk_client_id = "";
                  this.ConsoleBookDetails.fk_agent_id = "";
                  this.ConsoleBookDetails.booking_for = "";
                  this.ConsoleBookDetails.fk_shippingline_id = "";
                  this.ConsoleBookDetails.fk_branch_id = "";
                  this.ConsoleBookDetails.fk_enq_price_id = "";
                  this.ConsoleBookDetails.bookingType = "";
                }
              } else {
                this.alert.content = data.MSG;
              }
              this.$refs["addPop"].open();
              // this.getData();
              this.viewBookingConsoleList("0", "1", "1");
            }
          })
          .catch((error) => {});
      }
    },
    closeModalAdd() {
      this.$refs["modal-Add-Open"].hide();
    },
    CancelBooking(item, status) {
      (this.booking_no = ""), (this.booking_id = ""), (this.booking_id = item.booking_id);
      this.booking_no = item.booking_no;
      this.$refs["modal-CancelBooking-conf"].show();
    },
    closeCancelBookingModal() {
      this.$refs["modal-CancelBooking-conf"].hide();
    },
    closingReason() {
      this.iscloseCBdisabled = true;
    },
    updateCancelBooking() {
      this.closingReasontxterr = "";
      if (this.closingReasontxt == "") {
        this.alert.content = "Please Enter Remark";
        this.$refs["addPop"].open();
        this.closingReasontxterr = "Please Enter Remark";
        this.iscloseCBdisabled = false;
      } else if (this.closingReasontxt != "") {
        let obj = {
          tableName: "console_booking",
          UpdateId: "booking_id",
          UpdateIdVal: this.booking_id,
          UpdateStatus_name: "BookingStatus",
          UpdateStatus_val: 3,
          // booking_id:item.booking_id,
          // status:item.status,
          booking_no: this.booking_no,
          // status_txt: item.status_txt,
          updated_status_txt: "Cancel",
          title: "Booking No.",
          closingReasontxt: this.closingReasontxt,
        };
        if (this.booking_id != "") {
          // console.log(obj);
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_ConsoleBooking/updateConsoleBookingStatus.php`,
            data: JSON.stringify(obj),
            crossDomain: true,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };
          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              if (status == 200 && data) {
                if (data.booking_id != "" && data.booking_id != undefined) {
                  if (data.find == 1) {
                    this.alert.content = data.MSG;
                  } else {
                    this.alert.content = data.MSG;
                    this.booking_no = "";
                    this.booking_id = "";
                  }
                } else {
                  this.alert.content = data.MSG;
                }
                this.$refs["modal-CancelBooking-conf"].hide();
                this.$refs["addPop"].open();

                this.viewBookingConsoleList("0", "1", "1");
              }
            })
            .catch((error) => {});
        }
      }
    },
    getReports(id, btnName) {
      this.isLoading = true;
      let excelIdGivin = "";
      if (id == "ConsoleBooking_SCREEN") {
        excelIdGivin = "ConsoleBooking_SCREEN";
      }
      let view_Assignment = {
        excelId: excelIdGivin,
        clientIdFilter: this.clientIdFilter,
        agentIdFilter: this.agentIdFilter,
        ShippingLineFilter: this.ShippingLineFilter,
        BranchFilter: this.BranchFilter,
        BookingNoFilter: this.BookingNoFilter,
        BRFNoFilter: this.BRFNoFilter,
        BookingStatusFilter: this.BookingStatusFilter,
        PORfilter: this.PORfilter,
        PODfilter: this.PODfilter,
        POLfilter: this.POLfilter,
        fk_contract_idFilter:this.fk_contract_idFilter,
        fk_ccbm_idFilter:this.fk_ccbm_idFilter,
        searchVal: this.filter,

        assignmentNo: "assignmentNo",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
      };
      this.ExcelBtnName = "Downloading Please Wait...";
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_ConsoleBooking/getAlllExcelConsoleBooking.php`,
        data: JSON.stringify(view_Assignment),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.excelName != undefined) {
              this.ExcelBtnName = btnName;
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewBookingConsoleList(CURRENT, "2", event);
    },
    filterSearch() {
      this.reload = false;
      this.viewBookingConsoleList("0", "1", "1");
    },
    clearFilter() {
      this.clientIdFilter = "";
      this.agentIdFilter = "";
      this.ShippingLineFilter = "";
      this.BranchFilter = "";
      this.BookingNoFilter = "";
      this.BRFNoFilter = "";
      this.BookingStatusFilter = "";
      this.PORfilter = "";
      this.PODfilter = "";
      this.POLfilter = "";
      this.fk_contract_idFilter = "";
      this.fk_ccbm_idFilter = "";

      (this.dateRange = {
        startDate: "",
        endDate: "",
      }),
        this.viewBookingConsoleList("0", "1", "1");
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }
      this.viewBookingConsoleList(CURRENT, "2", event);
    },
    JqueryFun() {
      return $(function () {
        return $("#conBooking").DataTable();
      });
    },
    getContractNoBasedVessel(fk_contract_idFilter){
      this.$store.dispatch("common/setAllContractBasedVesselList", {
          filter: "ContractVesselList",
          active: "all",
          isAll: 0,
          ccbm_is_active: 1,
          ccbm_is_deleted: 0,
          isSelectedColumn: 0,
          // isSelectedColumn: 1,
          fk_cb_id: fk_contract_idFilter,
          is_withoutcb: 1,
       });
    },
    viewBookingConsoleList(CURRENT, SEARCH, pageNumber) {
      this.consoBooking = [];
      this.isLoading = true;
      // console.log("this.$sessionsStorage=>",this.$sessionsStorage)
      let payload = {
        // common_item:this.common_item;
        cust_username: this.$sessionsStorage.get("cust_username"),
        clientIdFilter: this.clientIdFilter,
        agentIdFilter: this.agentIdFilter,
        ShippingLineFilter: this.ShippingLineFilter,
        BranchFilter: this.BranchFilter,
        BookingNoFilter: this.BookingNoFilter,
        BRFNoFilter: this.BRFNoFilter,
        BookingStatusFilter: this.BookingStatusFilter,
        PORfilter: this.PORfilter,
        PODfilter: this.PODfilter,
        POLfilter: this.POLfilter,
        fk_contract_idFilter:this.fk_contract_idFilter,
        fk_ccbm_idFilter:this.fk_ccbm_idFilter,
        searchVal: this.filter,
        fields: this.fields,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        CBooking: "CBooking",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
        dataType:'CBList',
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_ConsoleBooking/viewAllconsoleBookingList.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.totalRows = data.totalData;
            if (SEARCH != "2") {
              this.currentPage = 1;
              if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }
            // console.log("Priyanshu Singh=>", data);
            if (data.UserData.length > 0) {
              if (
                data.UserData[0].designation == "Admin" ||
                this.$sessionsStorage.get("cust_username") == "admin" ||
                this.$sessionsStorage.get("cust_username") == "shankarrawat" ||
                this.$sessionsStorage.get("cust_username") == "vijaysharma" ||
                this.$sessionsStorage.get("cust_username") == "rathishnair" ||
                this.$sessionsStorage.get("cust_username") == "aaryav"
              ) {
                // this.BranchFilter = '';
              } else {
                this.BranchFilter = data.UserData[0].baseLocation;
                this.ConsoleBookDetails.fk_branch_id = data.UserData[0].baseLocation;
              }
            }
            if (data.consoleBookingData.length > 0) {
              // this.consoBooking = data.consoleBookingData;
              data.consoleBookingData.forEach((element) => {
                // console.log("Element => ", element);

                if (element.BookingStatus == 2) {
                  element["status_txt"] = "RELEASED";
                  element["status"] = 1;
                } else if (element.BookingStatus == 1) {
                  element["status_txt"] = "UNRELEASED";
                  element["status"] = 2;
                }
                element["booking_type_status"] = element.booking_type_status;
                element["container_count_arr"] = element.container_count_arr;
                element["booking_id"] = element.booking_id;
                element["contract_no"] = element.contract_no;
                element["fk_contarct_id"] = element.fk_contarct_id;
                element["booking_no"] = element.booking_no;
                element["bookingType"] = element.bookingType;
                element["fk_shippingline_id"] = element.fk_shippingline_id;
                element["fk_branch_id"] = element.fk_branch_id;
                element["fk_enq_price_id"] = element.fk_enq_price_id;
                element["fk_client_id"] = element.fk_client_id;
                element["fk_agent_id"] = element.fk_agent_id;
                element["booking_for"] = element.booking_for;
                element["addedBy_user_baseLocation"] = element.addedBy_user_baseLocation;
                element["BookingStatus"] = element.BookingStatus;
                element["isbookingactive"] = element.isbookingactive;
                if (element.isbookingactive == 0) {
                  element["bookingactive_status_txt"] = "Recover";
                  element["bookingactive_status"] = 1;
                } else if (element.isbookingactive == 1) {
                  element["bookingactive_status_txt"] = "Remove";
                  element["bookingactive_status"] = 0;
                }
                element["fk_por_id"] = element.fk_por_id;
                element["fk_pod_id"] = element.fk_pod_id;
                element["fk_pol_id"] = element.fk_pol_id;
                element["Branch_Name"] = element.Branch_Name;
                element["validity_start"] = element.validity_start;
                element["validity_end"] = element.validity_end;
                element["vessel_sale_start_date"] = element.vessel_sale_start_date;
                element["vessel_sale_end_date"] = element.vessel_sale_end_date;
                element["validity_doc"] = element.validity_doc;
                // alert(element.validity_doc);
                if (element.validity_doc != null || element.validity_doc != undefined)
                  element["validity_docArr"] = element.validity_doc.split(",");

                element["containerTypeDet"] = element.containerTypeDet;
                element["remark"] = element.remark;
                element["closingReasontxt"] = element.closingReasontxt;
                element["closedBy"] = element.closedBy;
                element["isbookingactive"] = element.isbookingactive;
                element["release_date"] = element.release_date;
                if (element.containerTypeDet == "") element["containerTypeDet"] = [];
                else element["containerTypeDet"] = element.containerTypeDet;
                // element["release_date"] = element.release_date;
                // if(element.containerTypeDet !="" && element.containerTypeDet !=null){
                //   element["containerTypeDet"] =  JSON.parse(element.containerTypeDet);
                //   this.items =  JSON.parse(element.containerTypeDet);
                // }else{
                //   element.containerTypeDet =  [];
                //   this.items = [];
                // }
                // console.log(
                //   "this.element.containerTypeDet=>",
                //   element.containerTypeDet
                // );
                this.consoBooking.push(element);
              });
            } else {
              this.consoBooking = [];
            }
            // console.log("this.consoBooking=>",this.consoBooking)
            if (this.reload == true) {
              if (data.clientMaster.length > 0) {
                this.clientMaster = data.clientMaster;
              }
              if (data.ShippingLineList.length > 0) {
                this.ShippingLineList = data.ShippingLineList;
              }
              if (data.BranchList.length > 0) {
                this.BranchList = data.BranchList;
              }
              // console.log("data=>", data);
              if (data.PORList.length > 0) {
                this.finalAllPlaceDataPOR = data.PORList;
              }
              if (data.PODList.length > 0) {
                this.finalAllPlaceDataPOD = data.PODList;
              }
              if (data.POLList.length > 0) {
                this.finalAllPlaceDataLP = data.POLList;
              }
              if (data.LocationDetailsFinal.length > 0) {
                // this.finalAllPlaceDataPOR = data.PORList;
                // this.finalAllPlaceDataPOD = data.PODList;
                // this.finalAllPlaceDataLP = data.POLList;
                // this.finalAllPlaceDataPOR = data.LocationDetailsFinal;
                // this.finalAllPlaceDataPOD = data.LocationDetailsFinal;
                // this.finalAllPlaceDataLP = data.LocationDetailsFinal;
              }
              if (data.containerList.length > 0) {
                this.containerList = data.containerList;
              }
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    viewlocationDetails(item) {
      console.log("SPS=>",item)
      let payload = {
        por_id: item.fk_por_id ? item.fk_por_id : "",
        pod_id: item.fk_pod_id ? item.fk_pod_id : "",
        pol_id: item.fk_pol_id ? item.fk_pol_id : "",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_ConsoleBooking/getlocationdata.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            // console.log("Priyanshu Singh Location Data=>", data);

            if (data.PORList.length > 0) {
              this.finalAllPlaceDataPOR = data.PORList;
            }
            if (data.PODList.length > 0) {
              this.finalAllPlaceDataPOD = data.PODList;
            }
            if (data.POLList.length > 0) {
              this.finalAllPlaceDataLP = data.POLList;
            }
          }
        })
        .catch((error) => {});
    },
    validateConsoleBooking() {
      let validate_new = true;
      if(this.ConsoleBookDetails.bookingType == 'ON CONTRACT'){
        this.errorCBDetails= {
          booking_no: "",
          contract_no: "",
          fk_client_id: "",
          // fk_agent_id: "",
          fk_shippingline_id: "",
          fk_branch_id: "",
          bookingType: "",
          // fk_enq_price_id:"",
        };
      }else{
        this.errorCBDetails= {
          booking_no: "",
          // contract_no: "",
          fk_client_id: "",
          // fk_agent_id: "",
          fk_shippingline_id: "",
          fk_branch_id: "",
          bookingType: "",
          // fk_enq_price_id:"",
        };
      }
      Object.keys(this.errorCBDetails).map((x, index) => {
       
        if (this.ConsoleBookData[x] == "") {
          // alert("Pri");
          // console.log("this.ConsoleBookData[x]=>", this.ConsoleBookData[x]);
          // console.log("this.errorCBDetails[x]=>", this.errorCBDetails);
          // console.log("x=>", x);
          // console.log("y=>", this.arrayErrorCBDetails[0][x]);
          if(x=='bookingType'){

          }
          this.errorCBDetails[x] = this.arrayErrorCBDetails[0][x];
          validate_new = false;
        }
      });
      // console.log("this.errorCBDetails=>", this.errorCBDetails);
      // console.log("this.arrayErrorCBDetails=>", this.arrayErrorCBDetails);
      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    submitConsoleBooking() {
      this.ConsoleBookData["booking_no"] = this.ConsoleBookDetails.booking_no;
      this.ConsoleBookData["fk_client_id"] = this.ConsoleBookDetails.fk_client_id;
      this.ConsoleBookData["fk_agent_id"] = this.ConsoleBookDetails.fk_agent_id;
      this.ConsoleBookData["booking_for"] = this.ConsoleBookDetails.booking_for;
      this.ConsoleBookData[
        "fk_shippingline_id"
      ] = this.ConsoleBookDetails.fk_shippingline_id;
      this.ConsoleBookData["fk_branch_id"] = this.ConsoleBookDetails.fk_branch_id;
      this.ConsoleBookData["CBType"] = this.ConsoleBookDetails.CBType;
      this.ConsoleBookData["booking_id"] = this.ConsoleBookDetails.booking_id;
      this.ConsoleBookData["bookingType"] = this.ConsoleBookDetails.bookingType;
      this.ConsoleBookData["fk_enq_price_id"] = this.ConsoleBookDetails.fk_enq_price_id;
      
      if (this.ConsoleBookData["bookingType"] == "ON CONTRACT"){
        this.ConsoleBookData["contract_no"] = this.ConsoleBookDetails.contract_no;
        this.ConsoleBookData["fk_contarct_id"] = this.ConsoleBookDetails.fk_contarct_id;
      } 

      this.validateConsoleBooking();
      if (this.validate == false) return false;

      this.isLoading = true;
      this.ShowSendApproval = false;
      // this.ConsoleBookData["booking_no"] = this.ConsoleBookDetails.booking_no;
      // this.ConsoleBookData["fk_client_id"] = this.ConsoleBookDetails.fk_client_id;
      // this.ConsoleBookData["fk_agent_id"] = this.ConsoleBookDetails.fk_agent_id;
      // this.ConsoleBookData["booking_for"] = this.ConsoleBookDetails.booking_for;
      // this.ConsoleBookData["fk_shippingline_id"] = this.ConsoleBookDetails.fk_shippingline_id;
      // this.ConsoleBookData["CBType"] = this.ConsoleBookDetails.CBType;
      // this.ConsoleBookData["booking_id"] = this.ConsoleBookDetails.booking_id;
      this.isCBdisabled = true;
      // console.log("this.ConsoleBookDetails=>", this.ConsoleBookDetails);
      // return false;
      if (this.validate != false) {
        // console.log(this.ConsoleBookDetails);
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_ConsoleBooking/addConsoleBooking.php`,
          data: JSON.stringify(this.ConsoleBookDetails),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.booking_id != "" && data.booking_id != undefined) {
                if (data.find == 1) {
                  this.alert.content = data.MSG;
                  this.validate = true;
                } else {
                  this.alert.content = data.MSG;
                  this.ConsoleBookDetails.booking_id = "";
                  this.ConsoleBookDetails.booking_no = "";
                  this.ConsoleBookDetails.contract_no = "";
                  this.ConsoleBookDetails.fk_contarct_id = "";
                  this.ConsoleBookDetails.fk_client_id = "";
                  this.ConsoleBookDetails.fk_agent_id = "";
                  this.ConsoleBookDetails.booking_for = "";
                  this.ConsoleBookDetails.fk_shippingline_id = "";
                  this.ConsoleBookDetails.fk_branch_id = "";
                  this.ConsoleBookDetails.fk_enq_price_id = "";
                  this.ConsoleBookDetails.bookingType = "";
                  this.validate = true;
                }
              } else {
                this.alert.content = data.MSG;
                this.validate = true;
              }
              this.errorCBDetails= {
                booking_no: "",
                contract_no: "",
                // fk_client_id: "",
                // fk_agent_id: "",
                fk_shippingline_id: "",
                fk_branch_id: "",
                bookingType: "",
                // fk_enq_price_id:"",
              };
              this.isCBdisabled = false;

              Object.keys(this.ConsoleBookData).map((x) => {
                this.ConsoleBookData[x] = "";
              });
              this.$refs["modal-Add-Open"].hide();
              this.$refs["addPop"].open();
              // this.getData();
              this.viewBookingConsoleList("0", "1", "1");
            }
          })
          .catch((error) => {});
      }
    },
    UpdateBookingStatus(status, item, status_txt) {
      let updated_status_txt = "";
      if (status_txt == "RELEASED") {
        updated_status_txt = "UNRELEASED";
      } else if (status_txt == "UNRELEASED") {
        updated_status_txt = "RELEASED";
      }
      let obj = {
        tableName: "console_booking",
        UpdateId: "booking_id",
        UpdateIdVal: item.booking_id,
        UpdateStatus_name: "BookingStatus",
        UpdateStatus_val: item.status,
        // booking_id:item.booking_id,
        // status:item.status,
        status_txt: item.status_txt,
        updated_status_txt: updated_status_txt,
        title: "Booking No.",
      };
      if (status != "") {
        // console.log(obj);
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_ConsoleBooking/updateConsoleBookingStatus.php`,
          data: JSON.stringify(obj),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.booking_id != "" && data.booking_id != undefined) {
                if (data.find == 1) {
                  this.alert.content = data.MSG;
                } else {
                  this.alert.content = data.MSG;
                  this.ConsoleBookDetails.booking_id = "";
                  this.ConsoleBookDetails.booking_no = "";
                  this.ConsoleBookDetails.contract_no = "";
                  this.ConsoleBookDetails.fk_contarct_id = "";
                  this.ConsoleBookDetails.fk_client_id = "";
                  this.ConsoleBookDetails.fk_agent_id = "";
                  this.ConsoleBookDetails.booking_for = "";
                  this.ConsoleBookDetails.fk_shippingline_id = "";
                  this.ConsoleBookDetails.fk_branch_id = "";
                  this.ConsoleBookDetails.fk_enq_price_id = "";
                  this.ConsoleBookDetails.bookingType = "";
                }
              } else {
                this.alert.content = data.MSG;
              }
              this.$refs["addPop"].open();

              this.viewBookingConsoleList("0", "1", "1");
              if (data.updated_status_txt == "RELEASED") {
                this.$refs["modal-AddOther-Open"].show();
              }
            }
          })
          .catch((error) => {});
      }
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };

      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    changeContractNo(contract_no){
      let ContractArr = this.$store.getters['common/getAllMultiContractList'].filter(x => {
                return x.text == contract_no;
              });
      if(ContractArr.length>0){
        // console.log("ContractArr=>",ContractArr);
        this.ConsoleBookDetails.fk_contarct_id=ContractArr[0].value;
      }
      // ConsoleBookDetails.contract_no
    },
    onFileChangeBlDraft_master_upload(e) {
      let ID = "CBValidityDoc";
      this.isLoading = true;
      let files = this.CBValidityDetails.validity_doc;
      let formData = new FormData();
      let booking_id = this.CBValidityDetails.booking_id;
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);

        if (ID == "CBValidityDoc") {
          formData.append(
            "staticFileName",
            "BOOKING_ORDER_" +
              this.CBValidityDetails.booking_id +
              this.CBValidityDetails.booking_no
          );
        }

        formData.append("upload_dir_folderName", "Console_Booking_Doc");
        formData.append("folderName", "Console_Booking_Doc");
        formData.append("folderPath", "Console_Booking_Doc");
        formData.append("moduleType", "Console_Booking");
        formData.append("moduleName", "Console_Booking");
        formData.append("ID", this.CBValidityDetails.booking_id);
        formData.append("Name", this.CBValidityDetails.booking_no);
        formData.append("itemCode", "ALL_FILE_UPLOAD");
        formData.append("fileArr", files);
      }

      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: ID + booking_id,
        },
      };

      axios
        .post(`${URL_BASE}/Api_ProformaInvoices/allMaster.php`, formData, config)
        .then((result) => {
          // console.log(result.data.imgPath);
          if (ID == "CBValidityDoc") {
            if (result.data.imgPath.length > 0) {
              this.CBValidityDetails.validity_doc = result.data.imgPath[0];
            } else {
              this.CBValidityDetails.validity_doc = "";
              // this.CBValidityDetails.validity_doc = result.data.imgPath;
            }
          } else {
            if (result.data.imgPath.length > 0) {
              this.CBValidityDetails.validity_doc = result.data.imgPath[0];
            } else {
              this.CBValidityDetails.validity_doc = "";
              // this.CBValidityDetails.validity_doc = result.data.imgPath;
            }
          }
          this.isLoading = false;
        })
        .catch((err) => {
          throw err;
        });
    },
    onFileChangeBlDraft(e) {
      let ID = "CBValidityDoc";
      this.isLoading = true;
      // console.log("file v-model => ", this.CBValidityDetails.validity_doc)
      // console.log("file e => ", e);
      // return;
      // console.log("val=>",val)
      let files = this.CBValidityDetails.validity_doc;
      // let files = val;
      // let files = event.target.files || event.dataTransfer.files;
      let formData = new FormData();
      // formData.append("file", files);
      // console.log("files=>", files.length);
      let booking_id = this.CBValidityDetails.booking_id;
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);

        if (ID == "CBValidityDoc") {
          formData.append(
            "staticFileName",
            "BOOKING_ORDER_" +
              this.CBValidityDetails.booking_id +
              this.CBValidityDetails.booking_no
          );
        }

        formData.append("upload_dir_folderName", "Console_Booking_Doc");
      }

      // console.log(formData);

      // console.log("Upload => ", formData);

      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: ID + booking_id,
        },
      };

      axios
        // .post(`${URL_BASE}/uploadFileAWS_S3.php`, formData, config)
        .post(`${URL_BASE}/uploadFileCommonForAllTest.php`, formData, config)
        // .post(`${URL_BASE}/uploadFileCommonForAllVP.php`, formData, config)
        .then((result) => {
          if (ID == "CBValidityDoc") {
            this.CBValidityDetails.validity_doc = result.data;
          } else {
            this.CBValidityDetails.validity_doc = "";
            // this.CBValidityDetails.validity_doc = result.data;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          throw err;
        });
    },
    validateCONCDetail() {
      let validate_new = true;
      let errCount = 0;

      let MainARR = this.CONTAINERCOUNTArr;
      for (let j = 0; j < MainARR.length; j++) {
        if (MainARR[j].cont_type == "") {
          this.CONTAINERCOUNTArr[j].cont_type_err =
            "Container Type " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
          // break;
        } else {
          this.CONTAINERCOUNTArr[j].cont_type_err = "";
          validate_new = true;
        }

        if (MainARR[j].cont_count == "") {
          this.CONTAINERCOUNTArr[j].cont_count_err =
            "Container Count " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
          // break;
        } else {
          this.CONTAINERCOUNTArr[j].cont_count_err = "";
          validate_new = true;
        }

        if (MainARR[j].currency == "") {
          this.CONTAINERCOUNTArr[j].currency_err =
            "Currency " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
          // break;
        } else {
          this.CONTAINERCOUNTArr[j].currency_err = "";
          validate_new = true;
        }
        if (
          MainARR[j].buying_ocean_freight == "" ||
          MainARR[j].buying_ocean_freight <= 0
        ) {
          if (MainARR[j].buying_ocean_freight == "") {
            this.CONTAINERCOUNTArr[j].buying_ocean_freight_err =
              "Buying Ocean Freight " + parseInt(j + 1) + " Field is Required";
            validate_new = false;
            ++errCount;
          } else if (MainARR[j].buying_ocean_freight <= 0) {
            this.CONTAINERCOUNTArr[j].buying_ocean_freight_err =
              "Please Enter Correct Buying Ocean Freight " + parseInt(j + 1) + " Amount";
            validate_new = false;
            ++errCount;
          }

          // break;
        } else {
          this.CONTAINERCOUNTArr[j].buying_ocean_freight_err = "";
          validate_new = true;
        }
      }
      // alert(errCount);
      if (errCount > 0) {
        this.validateCONC = false;
      } else {
        this.validateCONC = true;
      }
    },
    submitOtherConsoleBooking() {
      this.MessageFlag = false;
      this.validity_doc_error = false;
      if (this.booking_type_status == "0") {
        if (this.CBValidityDetails.containerTypeDet.length <= 0) {
          // this.alert.content = "Please Select Container Type Details";
          // this.$refs["addPop"].open();
          this.Message = "Please Select Container Type Details";
          this.MessageFlag = true;
          this.$refs["modal-CancelBooking-conf"].show();
          return false;
        }
        this.CBValidityData["containerTypeDet"] = this.CBValidityDetails.containerTypeDet;
        this.CBValidityData["container_count_arr"] = "";
        this.CBValidityDetails.container_count_arr = this.CBValidityData[
          "container_count_arr"
        ];
      } else if (this.booking_type_status == "1") {
        this.validateCONCDetail();
        // alert(this.validateCONC)
        if (this.validateCONC == false) {
          return false;
        }
        this.CBValidityData["container_count_arr"] = JSON.stringify(
          this.CONTAINERCOUNTArr
        );
        this.CBValidityDetails.container_count_arr = this.CBValidityData[
          "container_count_arr"
        ];
        this.CBValidityDetails.containerTypeDet = [];
      }
      // return false;JSON.stringify()

      this.CBValidityData["booking_id"] = this.CBValidityDetails.booking_id;
      this.CBValidityData["booking_no"] = this.CBValidityDetails.booking_no;
      this.CBValidityData["bookingType"] = this.CBValidityDetails.bookingType;
      this.CBValidityData["BookingStatus"] = this.CBValidityDetails.BookingStatus;
      this.CBValidityData["remark"] = this.CBValidityDetails.remark;
      this.CBValidityData["fk_pol_id"] = this.CBValidityDetails.fk_pol_id;
      this.CBValidityData["fk_pod_id"] = this.CBValidityDetails.fk_pod_id;
      this.CBValidityData["fk_por_id"] = this.CBValidityDetails.fk_por_id;
      this.CBValidityData["fk_ccbm_id"] = Number(this.CBValidityDetails.fk_ccbm_id);

      this.CBValidityData["validity_end"] = this.CBValidityDetails.validity_end;
      this.CBValidityData["validity_start"] = this.CBValidityDetails.validity_start;
      this.CBValidityData[
        "vessel_sale_start_date"
      ] = this.CBValidityDetails.vessel_sale_start_date;
      this.CBValidityData[
        "vessel_sale_end_date"
      ] = this.CBValidityDetails.vessel_sale_end_date;

      // this.CBValidityData["sicutoff"] = this.CBValidityDetails.sicutoff;
      // this.CBValidityData["vesselEta"] = this.CBValidityDetails.vesselEta;
      // this.CBValidityData["vesselEtd"] = this.CBValidityDetails.vesselEtd;
      // this.CBValidityData["voyageNo"] = this.CBValidityDetails.voyageNo;
      // this.CBValidityData["vesselName"] = this.CBValidityDetails.vesselName;

      let lengthDoc =
        this.CBValidityDetails.validity_doc != undefined
          ? this.sanitizedArray(this.CBValidityDetails.validity_doc.split(","))
          : [];
      if (lengthDoc.length <= 0) {
        this.validate = false;
        this.validity_doc_error = true;
      }

      this.CBValidityData["validity_doc"] = this.CBValidityDetails.validity_doc;
      this.CBValidityData[
        "multipleContainerType"
      ] = this.CBValidityDetails.multipleContainerType;
      this.validateOtherConsoleBooking();
      console.log("this.validate=>", this.validate);
      console.log("this.validity_doc_error=>", this.validity_doc_error);
      if (this.validate == false || this.validity_doc_error ==true) return false;

      this.isLoading = true;
      this.ShowSendApproval = false;
      // this.CBValidityData["booking_no"] = this.CBValidityDetails.booking_no;
      // this.CBValidityData["fk_client_id"] = this.CBValidityDetails.fk_client_id;
      // this.CBValidityData["fk_agent_id"] = this.CBValidityDetails.fk_agent_id;
      // this.CBValidityData["booking_for"] = this.CBValidityDetails.booking_for;
      // this.CBValidityData["fk_shippingline_id"] = this.CBValidityDetails.fk_shippingline_id;
      // this.CBValidityData["CBType"] = this.CBValidityDetails.CBType;
      // this.CBValidityData["booking_id"] = this.CBValidityDetails.booking_id;
      this.isOtherCBdisabled = true;
      // console.log("this.CBValidityDetails=>", this.CBValidityDetails);
      // return false;
      // alert(this.validate);
      if (this.validate != false) {
        // console.log("Add Other Console Booking=>",this.CBValidityData);
        // console.log("Add Other Console Booking=>",this.CONTAINERCOUNTArr);
        // return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_ConsoleBooking/addOtherConsoleBooking.php`,
          data: JSON.stringify(this.CBValidityDetails),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              // console.log("data=>",data)
              if (data.booking_id != "" && data.booking_id != undefined) {
                // alert(data.MSG);
                // alert(data.booking_id);
                // alert(data.find);
                if (data.find == 1) {
                  this.alert.content = data.MSG;
                } else {
                  // alert("Enterde")
                  this.alert.content = data.MSG;
                  this.CBValidityDetails = "";
                  // this.CBValidityDetails.booking_id = "";
                  // this.CBValidityDetails.booking_no = "";
                  // this.CBValidityDetails.BookingStatus = "";
                  // this.CBValidityDetails.remark = "";
                  // this.CBValidityDetails.POL = "";
                  // this.CBValidityDetails.POD = "";
                  // this.CBValidityDetails.POR = "";
                  // this.CBValidityDetails.containerTypeDet = [];
                  // this.CBValidityDetails.validity_end = "";
                  // this.CBValidityDetails.validity_start = "";
                  // this.CBValidityDetails.validity_doc = "";
                  // this.CBValidityDetails.multipleContainerType = [];
                }
              } else {
                this.alert.content = data.MSG;
              }
              this.isOtherCBdisabled = false;

              Object.keys(this.CBValidityData).map((x) => {
                this.CBValidityData[x] = "";
              });
              this.$refs["modal-AddOther-Open"].hide();
              this.$refs["addPop"].open();
              // this.getData();
              this.viewBookingConsoleList("0", "1", "1");
            }
          })
          .catch((error) => {});
      }
    },
    validateOtherConsoleBooking() {
      this.errorCBValidityDetails= {
        booking_no: "",
        fk_pol_id: "",
        fk_pod_id: "",
        fk_por_id: "",
        // containerTypeDet: "",
        validity_end: "",
        validity_start: "",
        vessel_sale_start_date: "",
        vessel_sale_end_date: "",
        fk_ccbm_id: "",
        validity_doc: "",
      };
      this.isOtherCBdisabled = false;
      let validate_new = true;
      Object.keys(this.errorCBValidityDetails).map((x, index) => {
        if (this.CBValidityData[x] == "" || this.CBValidityData[x] == "null" || this.CBValidityData[x] == "undefined" || this.CBValidityData[x] == undefined || this.CBValidityData[x] == null) {
          console.log("Pri",this.CBValidityData[x],x);
          this.errorCBValidityDetails[x] = this.arrayErrorCBValidityDetails[0][x];
          validate_new = false;
          this.isOtherCBdisabled = true;
        }
      });
      console.log("this.errorCBValidityDetails=>", this.errorCBValidityDetails);
      console.log(
        "this.arrayErrorCBValidityDetails=>",
        this.arrayErrorCBValidityDetails
      );
      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    addContainerCount() {
      let obj = {
        cont_type: "",
        cont_count: "",
        currency: "1",
        buying_ocean_freight: "",

        cont_type_err: "",
        cont_count_err: "",
        currency_err: "",
        buying_ocean_freight_err: "",
      };
      this.CONTAINERCOUNTArr.push(obj);
    },
    removeContainerCount(index) {
      this.CONTAINERCOUNTArr.splice(index, 1);
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        this.CurrencyList = [];
        let payload = {
          Currency: "Currency_DropDown",
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/viewAllCurrencyList.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.CurrencyList.length > 0) {
                this.CurrencyList = data.CurrencyList;
              } else {
                this.CurrencyList = [];
              }
              return resolve(this.CurrencyList);
            }
          })
          .catch((error) => {});
      });
    },


    closeApprovalRequestModal() {
      this.showRequestCBType=1;
      this.$refs.ApprovalRequestModal.hide();
      this.viewBookingConsoleList("0", "1", "1");
    },
    sendApprovalRequestModal(item){
      this.showRequestCBType=2;
      this.requestCBItem=item;
      this.$refs.ApprovalRequestModal.show();
    },
    sendApprovalRequest(){
      console.log('sendApprovalRequest=>',this.requestCBItem)
      let payload = {};
      if(this.delay_reason){
      payload = Object.assign({
          excelId: "sendApprovalRequestBookingConsole",
          booking_type: this.requestCBItem.bookingType,
          booking_id: this.requestCBItem.booking_id,
          booking_no: this.requestCBItem.booking_no,
          delay_reason:this.delay_reason,
          delay_reason_remark:this.delay_reason_remark,
      }, this.requestCBItem);
      console.log('sendApprovalRequest payload=>',payload)
      MasterService.ConsoleBooking(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          // console.log();
          if (status == 200 && data.CBFLAG == 1) {
            this.showRequestCBType=1;
            // console.log("Success Reset= "+item.booking_no);
          }
          this.alert.content = data.CBMSG;
          this.$refs["addPop"].open();
          this.viewBookingConsoleList("0", "1", "1");
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on sendApprovalRequest Error: ", error);
        });
      }
    },
    getApprovalRequestLogReports(id, btnName) {
      this.isLoading = true;
      this.generateExcel = "1";
      this.ExcelBtnName = "Downloading Please Wait .....";
    },
    getApprovalRequestLog(item){
      this.CBApprovalLogList =[];
      this.$refs.ApprovalRequestModal.show();
      console.log('sendApprovalRequest=>',item)
      let payload = {};
      if(item.booking_id){
        payload = {
        itemCode: "getBookingApprovalLog",
        generateExcel: this.generateExcel,
        filter:{booking_id:item.booking_id},
        isAllNo: 1,
        isSelectedColumn: 0,
      };
      console.log('sendApprovalRequest payload=>',payload)
      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      NodeLockPannelService.getBookingApprovalLogList(payload,config)
        .then((response) => {
          const { data, status, statusText } = response;
          // console.log("data PS=>", data.data);

          if (status == 200 && data) {
            if (this.generateExcel == "1") {

              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "get-Job-Pendency-panel-report.xlsx"); // Specify the file name
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.generateExcel = "0";
             
            } else {
              if (data.data.length > 0) {
                this.totalData = data.meta.totalBookings;
                this.CBApprovalLogList = data.data;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getApprovalRequestLog Error: ", error);
        });
      }
    },
    async AddOtherCBDetails(type, item) {
      this.singleUpload=[];
      // console.log("designation",this.$sessionsStorage.get("designation").trim());
      // console.log("nameUser",this.$sessionsStorage.get("nameUser").trim());
      // this.CBValidityDetails.containerTypeDet = [];
      // alert(type)
      let locationArr = await this.viewlocationDetails(item);
      let CurrencyArr = await this.getCurrencyList();
      if (type == "edit") {
        // this.common_item=item;
        if (
          this.$sessionsStorage.get("designation") == "Admin" &&
          this.$sessionsStorage.get("nameUser") == "Bhavneesh"
        ) {
          this.CBValidityDetails_inputFlag = false;
          this.isOtherCBdisabled = false;
        } else {
          this.CBValidityDetails_inputFlag = true;
          this.isOtherCBdisabled = true;
        }
        // alert(this.isOtherCBdisabled);
        // alert(this.CBValidityDetails_inputFlag);
        this.CBValidityDetails = {
          remark: "",
          fk_pol_id: "",
          fk_pod_id: "",
          fk_por_id: "",
          containerTypeDet: [],
          validity_end: "",
          validity_start: "",
          vessel_sale_start_date: "",
          vessel_sale_end_date: "",
          // sicutoff: "",
          // vesselEta: "",
          // vesselEtd: "",
          // voyageNo: "",
          // vesselName: "",
          validity_doc: "",
          booking_id: "",
          multipleContainerType: [],
          multipleContainerTypeId: [],
          validity_doc: "",
          fk_ccbm_id: "",
          container_count_arr: "",
        };
        // alert(this.$sessionsStorage.get("designation"));
        // alert(this.$sessionsStorage.get("nameUser"));

        // alert(this.CBValidityDetails_inputFlag);
        // alert(this.isOtherCBdisabled);
        this.CBValidityDetails.containerTypeDet = [];
        this.CBValidityDetails.booking_id = "";
        this.CBValidityDetails.booking_no = "";
        this.CBValidityDetails.BookingStatus = "";
        // console.log("Other Details Priyanshu=>", item);
        // CBValidityDetails
        // alert( item.validity_doc);

        this.CBValidityDetails.remark = item.remark;
        this.CBValidityDetails.fk_pol_id = item.fk_pol_id;
        this.CBValidityDetails.fk_pod_id = item.fk_pod_id;
        this.CBValidityDetails.fk_por_id = item.fk_por_id;
        this.CBValidityDetails.fk_ccbm_id = Number(item.fk_ccbm_id);
        this.CBValidityDetails.validity_end = item.validity_end;
        this.CBValidityDetails.validity_start = item.validity_start;
        this.CBValidityDetails.vessel_sale_start_date = item.vessel_sale_start_date;
        this.CBValidityDetails.vessel_sale_end_date = item.vessel_sale_end_date;
        console.log("Other Details Priyanshu=>", this.CBValidityDetails);
        // this.CBValidityDetails.sicutoff = item.sicutoff;
        // this.CBValidityDetails.vesselEta = item.vesselEta;
        // this.CBValidityDetails.vesselEtd = item.vesselEtd;
        // this.CBValidityDetails.voyageNo = item.voyageNo;
        // this.CBValidityDetails.vesselName = item.vesselName;
        this.CBValidityDetails.validity_doc = item.validity_doc;
        this.CBValidityDetails.booking_id = item.booking_id;
        if (item.containerTypeDet != "" && item.containerTypeDet != null) {
          this.CBValidityDetails.containerTypeDet = JSON.parse(item.containerTypeDet);
          this.items = JSON.parse(item.containerTypeDet);
        } else {
          this.CBValidityDetails.containerTypeDet = [];
          this.items = [];
        }
        // this.CONTAINERCOUNTArr = [];
        if (item.booking_type_status == "1") {
          if (item.container_count_arr != "" && item.container_count_arr != null) {
            console.log('item.container_count_arr=>',item.container_count_arr)
            this.CONTAINERCOUNTArr = JSON.parse(item.container_count_arr);
          }
        }
        this.buttonTxt = "Update";
        this.CBValidityDetails.is_booing_response=item.is_booing_response;
        this.CBValidityDetails.booking_no=item.booking_no;
        // this.isOtherCBdisabled = true;
        // this.CBValidityDetails_inputFlag = true;
        // console.log(
        //   "Other Details CBValidityDetails=>",
        //   this.CBValidityDetails
        // );
        // this.getBookingConsoleDetails();
      } else if (type == "add") {
        // this.common_item={};
        this.CBValidityDetails_inputFlag = false;
        this.CBValidityDetails = {
          remark: "",
          fk_pol_id: "",
          fk_pod_id: "",
          fk_por_id: "",
          containerTypeDet: [],
          validity_end: "",
          validity_start: "",
          vessel_sale_start_date: "",
          vessel_sale_end_date: "",
          // sicutoff: "",
          // vesselEta: "",
          // vesselEtd: "",
          // voyageNo: "",
          // vesselName: "",
          validity_doc: "",
          booking_id: "",
          multipleContainerType: [],
          multipleContainerTypeId: [],
          fk_ccbm_id:"",
          container_count_arr: "",
        };
        this.isOtherCBdisabled = false;
        this.CBValidityDetails.containerTypeDet = [];
        this.CBValidityDetails.booking_id = "";
        this.CBValidityDetails.booking_no = "";
        this.CBValidityDetails.BookingStatus = "";
        this.CBValidityDetails.validity_doc = "";
        this.CBValidityDetails.is_booing_response=0;
         if (item.containerTypeDet != "" && item.containerTypeDet != null) {
          this.CBValidityDetails.containerTypeDet = JSON.parse(item.containerTypeDet);
          this.items = JSON.parse(item.containerTypeDet);
        } else {
          this.CBValidityDetails.containerTypeDet = [];
          this.items = [];
        }
        // this.CONTAINERCOUNTArr = [];
        if (item.booking_type_status == "1") {
          if (item.container_count_arr != "" && item.container_count_arr != null) {
            console.log('item.container_count_arr=>',item.container_count_arr)
            this.CONTAINERCOUNTArr = JSON.parse(item.container_count_arr);
          }
        }
        // console.log("Happy=>", item);
        // console.log("this.CBValidityDetails=>", this.CBValidityDetails);
      }
      this.booking_type_status = item.booking_type_status;
      this.CBValidityDetails.fk_pol_id = item.fk_pol_id;
      this.CBValidityDetails.fk_pod_id = item.fk_pod_id;
      this.CBValidityDetails.fk_por_id = item.fk_por_id;
      this.CBValidityDetails.fk_ccbm_id = Number(item.fk_ccbm_id);
      this.CBValidityDetails.booking_id = item.booking_id;
      this.CBValidityDetails.booking_no = item.booking_no;
      this.CBValidityDetails.BookingStatus = item.status;
      this.ChangeVessalesStartDate(item.vessel_sale_start_date);
      this.ChangeVessalesEndDate(item.vessel_sale_start_date);
      this.CBValidityDetails.is_booing_response=item.is_booing_response;
      this.validity_doc_error = false;
      this.$refs["modal-AddOther-Open"].show();
    },
    closeModalAddOther() {
      this.$refs["modal-AddOther-Open"].hide();
    },

    SelectContainerType(items, lastSelectItem) {
      // console.log("Priyanshu Singh=>", items[0]);
      this.items = items;
      this.CBValidityDetails.containerTypeDet = items;
    },
    // deleteContainer(item) {
    //   let i = this.CBValidityDetails.multipleContainerType.indexOf(item);
    //   this.CBValidityDetails.multipleContainerType.splice(i, 1);
    //   this.CBValidityDetails.multipleContainerTypeId.splice(i, 1);
    // },
    // masterCallbackContainer(item) {
    //   console.log("Priyanshu Singh item=>", item);
    //   if (this.CBValidityDetails.multipleContainerType.length > 0) {
    //     let i = this.CBValidityDetails.multipleContainerType.indexOf(
    //       item.containerType
    //     );

    //     if (i < 0) {
    //       this.CBValidityDetails.multipleContainerType.push(item.containerType);
    //       this.CBValidityDetails.multipleContainerTypeId.push(
    //         item.containerTypeId
    //       );
    //     }
    //   } else {
    //     this.CBValidityDetails.multipleContainerType.push(item.containerType);
    //     this.CBValidityDetails.multipleContainerTypeId.push(
    //       item.containerTypeId
    //     );
    //   }
    // },

    //Added By Priyanshu SIngh Multi Select Start

    SelectAll: function () {
      this.isCheckAll = !this.isCheckAll;
      this.AllBookingNo_ids = [];
      this.AllBookingNo_Series = [];
      this.AllClient_ids = [];
      if (this.isCheckAll) {
        // Check all
        for (var key in this.consoBooking) {
          // row0.item.revisedActionTakenFromMail !=1
          if (this.consoBooking[key].revisedActionTakenFromMail != 1) {
            let single_data = "";
            this.AllBookingNo_ids.push(this.consoBooking[key].allModuleId);
            this.AllBookingNo_Series.push(this.consoBooking[key].mainSalesSeries);
            this.AllClient_ids.push(this.consoBooking[key].ClientName);
          }
        }
      }
    },
    updateSelectAll: function (e, item) {
      if (this.AllBookingNo_ids.length == this.consoBooking.length) {
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }
      const istrue = this.AllBookingNo_ids.includes(item.allModuleId);
      if (istrue == true) {
        this.AllClient_ids.push(item.ClientName);
        this.AllBookingNo_Series.push(item.mainSalesSeries);
      } else {
        const index = this.AllClient_ids.indexOf(item.ClientName);
        const JobNo_Series_index = this.AllBookingNo_Series.indexOf(item.mainSalesSeries);
        this.AllClient_ids.splice(index, 1);
        this.AllBookingNo_Series.splice(JobNo_Series_index, 1);
      }
      // console.log("this.AllBookingNo_Series=>", this.AllBookingNo_Series);
    },
     goToSubscriptionPage(item) {
      if (item.SubscriptionId) {
        this.$router.push({
          path: "/tracking/ocean-insights/subscription/" + item.SubscriptionId,
        });
      }
    },
    pagechangeData() {
      this.perPage = this.PaginationCount;
      this.reload = false;
      this.viewBookingConsoleList("0", "1", "1");
    },
    checkCLient(ClientName) {
      return ClientName;
    },
    updateBookingRes(fk_enq_price_id){
      let PricingArr = this.$store.getters['enqPriceEngineDropdown/getAllEnqPriceDDList'].filter(x => {
          return x.value == fk_enq_price_id;
        });
      if(PricingArr.length>0){
        // console.log("ContractArr=>",ContractArr);
        this.ConsoleBookDetails.vesselEtd=PricingArr[0].etd;
        this.ConsoleBookDetails.fk_client_id=PricingArr[0].fk_client_id;
        this.ConsoleBookDetails.fk_shippingline_id=PricingArr[0].fk_shipping_id;
        this.ConsoleBookDetails.fk_agent_id=PricingArr[0].fk_agent_id;
        this.ConsoleBookDetails.fk_pol_id=PricingArr[0].fk_pol_id;
        this.ConsoleBookDetails.fk_por_id=PricingArr[0].fk_por_id;
        this.ConsoleBookDetails.fk_pod_id=PricingArr[0].fk_pod_id;
        this.ConsoleBookDetails.remark=PricingArr[0].remarks;
      }

    }           
    //Added By Priyanshu SIngh Multi Select End
  },
};
</script>



// WEBPACK FOOTER //
// ConsoleBooking.vue?6cdc1890